/* eslint-disable */
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  BigDecimal: { input: any; output: any }
  Date: { input: any; output: any }
  DateTime: { input: any; output: any }
}

export type Agrupador = {
  __typename?: 'Agrupador'
  active: Scalars['Boolean']['output']
  descricao: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type AgrupadorInput = {
  descricao: Scalars['String']['input']
  id?: InputMaybe<Scalars['ID']['input']>
}

export type AlteracaoCargosInputs = {
  __typename?: 'AlteracaoCargosInputs'
  cargoImpedindoAlteracao?: Maybe<Cargo>
  podeAlterar?: Maybe<Scalars['Boolean']['output']>
}

export type Anuncio = {
  __typename?: 'Anuncio'
  active: Scalars['Boolean']['output']
  arquivo: Arquivo
  createdDateTime: Scalars['DateTime']['output']
  emExibicao: Scalars['Boolean']['output']
  fimDate?: Maybe<Scalars['Date']['output']>
  grupos?: Maybe<Array<GrupoUsuarios>>
  id: Scalars['ID']['output']
  inicioDate?: Maybe<Scalars['Date']['output']>
  link?: Maybe<Scalars['String']['output']>
  linkTarget?: Maybe<Scalars['String']['output']>
  titulo: Scalars['String']['output']
}

export type AnuncioFilterInput = {
  dataFinal?: InputMaybe<Scalars['Date']['input']>
  dataInicial?: InputMaybe<Scalars['Date']['input']>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
  somenteAtivos?: InputMaybe<Scalars['Boolean']['input']>
  somenteEmExibicao?: InputMaybe<Scalars['Boolean']['input']>
  titulo?: InputMaybe<Scalars['String']['input']>
}

export type AnuncioInput = {
  fimDate?: InputMaybe<Scalars['Date']['input']>
  idAnuncio?: InputMaybe<Scalars['ID']['input']>
  idArquivo: Scalars['ID']['input']
  idsGrupos?: InputMaybe<Array<Scalars['ID']['input']>>
  inicioDate?: InputMaybe<Scalars['Date']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  linkTarget?: InputMaybe<Scalars['String']['input']>
  titulo: Scalars['String']['input']
}

export type AnuncioPage = {
  __typename?: 'AnuncioPage'
  content?: Maybe<Array<Maybe<Anuncio>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type Arquivo = {
  __typename?: 'Arquivo'
  bucket: Scalars['String']['output']
  dataUpload: Scalars['DateTime']['output']
  diretorioRemoto: Scalars['String']['output']
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
  nomeUnico: Scalars['String']['output']
  prefix: Scalars['String']['output']
  tamanho?: Maybe<Scalars['BigDecimal']['output']>
}

export type ArquivoDownload = {
  __typename?: 'ArquivoDownload'
  arquivo: Arquivo
  createdDateTime: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  usuario: Usuario
}

export type ArquivoInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type AtivacaoEspecialUsuario = {
  __typename?: 'AtivacaoEspecialUsuario'
  data: Scalars['DateTime']['output']
  justificativa: Scalars['String']['output']
  solicitante: Usuario
}

export type AtivacaoEspecialUsuarioInput = {
  data?: InputMaybe<Scalars['DateTime']['input']>
  justificativa: Scalars['String']['input']
  solicitante: Scalars['ID']['input']
  usuario: Scalars['ID']['input']
}

export type AtualizarMinhaContaInput = {
  avatar?: InputMaybe<ArquivoInput>
  avatarId?: InputMaybe<Scalars['String']['input']>
  celulares?: InputMaybe<Array<Scalars['String']['input']>>
  confirmaNovaSenha?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  nome: Scalars['String']['input']
  notificacoesUsuario?: InputMaybe<Array<InputMaybe<NotificacaoUsuarioInput>>>
  novaSenha?: InputMaybe<Scalars['String']['input']>
  senhaAtual?: InputMaybe<Scalars['String']['input']>
  telefones?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AusenciaTemporaria = {
  __typename?: 'AusenciaTemporaria'
  ausenciaTemporariaStatus?: Maybe<BaseEnum>
  dataInicio?: Maybe<Scalars['Date']['output']>
  dataRetorno?: Maybe<Scalars['Date']['output']>
  documentoComprobatorio?: Maybe<Arquivo>
  id?: Maybe<Scalars['ID']['output']>
  motivo?: Maybe<MotivoAusenciaTemporaria>
}

export type AusenciaTemporariaInput = {
  dataInicio: Scalars['Date']['input']
  dataRetorno: Scalars['Date']['input']
  documentoComprobatorioId: Scalars['ID']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  motivoId: Scalars['ID']['input']
  usuarioId: Scalars['ID']['input']
}

export type BaseEnum = {
  __typename?: 'BaseEnum'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type Cargo = {
  __typename?: 'Cargo'
  dataInicio?: Maybe<Scalars['Date']['output']>
  dealer?: Maybe<Dealer>
  departamento?: Maybe<Departamento>
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
}

export type CargoInput = {
  cargoId: Scalars['ID']['input']
  dataInicio: Scalars['Date']['input']
  dealerId?: InputMaybe<Scalars['ID']['input']>
  departamentoId?: InputMaybe<Scalars['ID']['input']>
}

export type Comunicado = {
  __typename?: 'Comunicado'
  active: Scalars['Boolean']['output']
  arquivos?: Maybe<Array<Maybe<Arquivo>>>
  createdDateTime: Scalars['DateTime']['output']
  dataHoraAgendamento?: Maybe<Scalars['DateTime']['output']>
  departamento?: Maybe<Departamento>
  emAprovacao: Scalars['Boolean']['output']
  emailsAvulsos?: Maybe<Array<Maybe<EmailAvulso>>>
  enviado: Scalars['Boolean']['output']
  envioDateTime?: Maybe<Scalars['DateTime']['output']>
  etiquetas?: Maybe<Array<Maybe<Etiqueta>>>
  grupos?: Maybe<Array<Maybe<GrupoUsuarios>>>
  id: Scalars['ID']['output']
  idParent?: Maybe<Scalars['String']['output']>
  mensagem: Scalars['String']['output']
  motivoRejeicao?: Maybe<Scalars['String']['output']>
  rascunho: Scalars['Boolean']['output']
  rejeitado: Scalars['Boolean']['output']
  status: BaseEnum
  templateName?: Maybe<Scalars['String']['output']>
  titulo: Scalars['String']['output']
  usuarioAprovador?: Maybe<Usuario>
  usuarioCriador: Usuario
  usuariosRemovidos?: Maybe<Array<Maybe<Usuario>>>
}

export type ComunicadoDashboard = {
  __typename?: 'ComunicadoDashboard'
  arquivados?: Maybe<Array<Maybe<ComunicadoEnvio>>>
  comunicado: Comunicado
  downloads?: Maybe<Array<Maybe<ArquivoDownload>>>
  enviados?: Maybe<Array<Maybe<ComunicadoEnvio>>>
  id: Scalars['ID']['output']
  lidos?: Maybe<Array<Maybe<ComunicadoEnvio>>>
}

export type ComunicadoEnvio = {
  __typename?: 'ComunicadoEnvio'
  active: Scalars['Boolean']['output']
  arquivado: Scalars['Boolean']['output']
  arquivamentoDateTime?: Maybe<Scalars['DateTime']['output']>
  comunicado?: Maybe<Comunicado>
  createdDateTime?: Maybe<Scalars['DateTime']['output']>
  favorito: Scalars['Boolean']['output']
  favoritoDateTime?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  leituraDateTime?: Maybe<Scalars['DateTime']['output']>
  lido: Scalars['Boolean']['output']
  status?: Maybe<StatusEmailEnum>
  usuario: Usuario
}

export type ComunicadoEnvioFilterInput = {
  dataFinal?: InputMaybe<Scalars['Date']['input']>
  dataInicial?: InputMaybe<Scalars['Date']['input']>
  etiqueta?: InputMaybe<Scalars['String']['input']>
  idsDepartamentos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  idsGruposUsuarios?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  isArquivado?: InputMaybe<Scalars['Boolean']['input']>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
  somenteComAnexo?: InputMaybe<Scalars['Boolean']['input']>
  somenteErratas?: InputMaybe<Scalars['Boolean']['input']>
  somenteFavoritas?: InputMaybe<Scalars['Boolean']['input']>
  somenteNaoLidas?: InputMaybe<Scalars['Boolean']['input']>
  titulo?: InputMaybe<Scalars['String']['input']>
}

export type ComunicadoEnvioPage = {
  __typename?: 'ComunicadoEnvioPage'
  content?: Maybe<Array<Maybe<ComunicadoEnvio>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type ComunicadoFilterInput = {
  comunicadoUsuarioTipo?: InputMaybe<ComunicadoUsuarioTipo>
  dataFinal?: InputMaybe<Scalars['Date']['input']>
  dataInicial?: InputMaybe<Scalars['Date']['input']>
  etiqueta?: InputMaybe<Scalars['String']['input']>
  idsDepartamentos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  idsGruposUsuarios?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
  somenteComAnexo?: InputMaybe<Scalars['Boolean']['input']>
  somenteErratas?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  titulo?: InputMaybe<Scalars['String']['input']>
}

export type ComunicadoInput = {
  /**  Enviar ISO String */
  dataHoraAgendamento?: InputMaybe<Scalars['String']['input']>
  emailsAvulsos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  idComunicado?: InputMaybe<Scalars['ID']['input']>
  idDepartamento?: InputMaybe<Scalars['ID']['input']>
  idParent?: InputMaybe<Scalars['ID']['input']>
  idsArquivos?: InputMaybe<Array<Scalars['ID']['input']>>
  idsGrupos?: InputMaybe<Array<Scalars['ID']['input']>>
  idsUsuariosRemovidos?: InputMaybe<Array<Scalars['ID']['input']>>
  mensagem: Scalars['String']['input']
  nomesEtiquetas?: InputMaybe<Array<Scalars['String']['input']>>
  templateName?: InputMaybe<Scalars['String']['input']>
  titulo: Scalars['String']['input']
}

export type ComunicadoPage = {
  __typename?: 'ComunicadoPage'
  content?: Maybe<Array<Maybe<Comunicado>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export enum ComunicadoUsuarioTipo {
  Aprovador = 'APROVADOR',
  Criador = 'CRIADOR'
}

export type ConcederAcessoInput = {
  idPasta?: InputMaybe<Scalars['ID']['input']>
  idsGrupoAcesso?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  tiposAcesso: Array<InputMaybe<TipoAcessoInput>>
}

export type DadoComplementar = {
  __typename?: 'DadoComplementar'
  descricao: Scalars['String']['output']
  funcionalidades: Array<Maybe<Funcionalidade>>
  id: Scalars['ID']['output']
  ordem: Scalars['Int']['output']
  tipo: Scalars['String']['output']
  urlBase: Scalars['String']['output']
}

export type Dealer = {
  __typename?: 'Dealer'
  active: Scalars['Boolean']['output']
  cnpj: Scalars['String']['output']
  cnpjsAdicionais?: Maybe<Array<Scalars['String']['output']>>
  codigoPrincipal: Scalars['String']['output']
  codigos?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  dadosComplementares: Array<Maybe<DadoComplementar>>
  email?: Maybe<Scalars['String']['output']>
  endereco: Endereco
  fimOperacao?: Maybe<Scalars['Date']['output']>
  grupo: Grupo
  id: Scalars['ID']['output']
  inicioOperacao?: Maybe<Scalars['Date']['output']>
  marcas?: Maybe<Array<Maybe<BaseEnum>>>
  nome: Scalars['String']['output']
  nomeExibicao: Scalars['String']['output']
  produtos?: Maybe<Array<Maybe<Produto>>>
  razaoSocial: Scalars['String']['output']
  telefones?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type DealerFilterInput = {
  busca?: InputMaybe<Scalars['String']['input']>
  estados?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  idsGrupos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  page: Scalars['Int']['input']
  razaoSocial?: InputMaybe<Scalars['String']['input']>
  rowsPerPage: Scalars['Int']['input']
}

export type DealerInput = {
  active: Scalars['Boolean']['input']
  cnpj: Scalars['String']['input']
  cnpjsAdicionais?: InputMaybe<Array<Scalars['String']['input']>>
  codigoPrincipal?: InputMaybe<Scalars['String']['input']>
  codigos?: InputMaybe<Array<Scalars['String']['input']>>
  email?: InputMaybe<Scalars['String']['input']>
  endereco: EnderecoInput
  fimOperacao?: InputMaybe<Scalars['Date']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  idGrupo: Scalars['ID']['input']
  idsProdutos?: InputMaybe<Array<Scalars['ID']['input']>>
  inicioOperacao?: InputMaybe<Scalars['Date']['input']>
  marcas?: InputMaybe<Array<Scalars['ID']['input']>>
  nome: Scalars['String']['input']
  razaoSocial: Scalars['String']['input']
  telefones?: InputMaybe<Array<Scalars['String']['input']>>
}

export type DealerPage = {
  __typename?: 'DealerPage'
  content?: Maybe<Array<Maybe<Dealer>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type Departamento = {
  __typename?: 'Departamento'
  assinatura?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
  sigla?: Maybe<Scalars['String']['output']>
}

export type Desligamento = {
  __typename?: 'Desligamento'
  id: Scalars['ID']['output']
  motivo: Scalars['String']['output']
}

export type Divisao = {
  __typename?: 'Divisao'
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
}

export type EmailAvulso = {
  __typename?: 'EmailAvulso'
  comunicado?: Maybe<Comunicado>
  email?: Maybe<Scalars['String']['output']>
  status?: Maybe<StatusEmailEnum>
}

export type Endereco = {
  __typename?: 'Endereco'
  bairro?: Maybe<Scalars['String']['output']>
  cep?: Maybe<Scalars['String']['output']>
  cidade?: Maybe<Scalars['String']['output']>
  complemento?: Maybe<Scalars['String']['output']>
  estado?: Maybe<BaseEnum>
  id: Scalars['ID']['output']
  latitude?: Maybe<Scalars['BigDecimal']['output']>
  logradouro?: Maybe<Scalars['String']['output']>
  longitude?: Maybe<Scalars['BigDecimal']['output']>
  numero?: Maybe<Scalars['Int']['output']>
}

export type EnderecoCep = {
  __typename?: 'EnderecoCEP'
  city?: Maybe<Scalars['String']['output']>
  neighborhood?: Maybe<Scalars['String']['output']>
  place?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  uf?: Maybe<Scalars['String']['output']>
}

export type EnderecoInput = {
  bairro?: InputMaybe<Scalars['String']['input']>
  cep?: InputMaybe<Scalars['String']['input']>
  cidade?: InputMaybe<Scalars['String']['input']>
  complemento?: InputMaybe<Scalars['String']['input']>
  estado?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  logradouro?: InputMaybe<Scalars['String']['input']>
  numero?: InputMaybe<Scalars['String']['input']>
}

export type Etiqueta = {
  __typename?: 'Etiqueta'
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
}

export type Funcionalidade = {
  __typename?: 'Funcionalidade'
  chave: Scalars['String']['output']
  dadosComplementares?: Maybe<Array<Maybe<DadoComplementar>>>
  descricao?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
  ordem: Scalars['Int']['output']
  produto: Produto
  tiposAcesso?: Maybe<Array<Maybe<TipoAcesso>>>
  tiposUsuario?: Maybe<Array<Maybe<BaseEnum>>>
}

export type Grupo = {
  __typename?: 'Grupo'
  active: Scalars['Boolean']['output']
  dealers?: Maybe<Array<Maybe<Dealer>>>
  id: Scalars['ID']['output']
  marcas?: Maybe<Array<Maybe<Marca>>>
  nome: Scalars['String']['output']
}

export type GrupoFilterInput = {
  busca?: InputMaybe<Scalars['String']['input']>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
}

export type GrupoInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  marcas?: InputMaybe<Array<Scalars['ID']['input']>>
  nome: Scalars['String']['input']
}

export type GrupoPage = {
  __typename?: 'GrupoPage'
  content?: Maybe<Array<Maybe<Grupo>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type GrupoUsuarios = {
  __typename?: 'GrupoUsuarios'
  active: Scalars['Boolean']['output']
  cargos?: Maybe<Array<Maybe<Cargo>>>
  criador?: Maybe<Usuario>
  dealers?: Maybe<Array<Maybe<Dealer>>>
  departamentos?: Maybe<Array<Maybe<Departamento>>>
  favorito?: Maybe<Scalars['Boolean']['output']>
  grupos?: Maybe<Array<Maybe<Grupo>>>
  id: Scalars['ID']['output']
  marcas?: Maybe<Array<Maybe<BaseEnum>>>
  nome: Scalars['String']['output']
  possuiCargos: Scalars['Boolean']['output']
  possuiDepartamentos?: Maybe<Scalars['Boolean']['output']>
  possuiGrupos?: Maybe<Scalars['Boolean']['output']>
  possuiPerfil: Scalars['Boolean']['output']
  possuiSetores: Scalars['Boolean']['output']
  possuiUsuariosManuais: Scalars['Boolean']['output']
  publico: Scalars['Boolean']['output']
  setores?: Maybe<Array<Maybe<Setor>>>
  tipo?: Maybe<BaseEnum>
  tiposAcesso?: Maybe<Array<Maybe<TipoAcesso>>>
  tiposUsuarios?: Maybe<Array<Maybe<BaseEnum>>>
  todosDealers: Scalars['Boolean']['output']
  usuariosManuais?: Maybe<Array<Maybe<Usuario>>>
}

export type GrupoUsuariosFilterInput = {
  busca?: InputMaybe<Scalars['String']['input']>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
}

export type GrupoUsuariosInput = {
  active: Scalars['Boolean']['input']
  cargos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  criador?: InputMaybe<Scalars['ID']['input']>
  dealers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  departamentos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  edit?: InputMaybe<Scalars['Boolean']['input']>
  grupos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  id?: InputMaybe<Scalars['ID']['input']>
  marcas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  nome: Scalars['String']['input']
  publico?: InputMaybe<Scalars['Boolean']['input']>
  setores?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  tipo: Scalars['String']['input']
  tiposAcesso?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  tiposUsuarios?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  todosDealers: Scalars['Boolean']['input']
  usuariosManuais?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type GrupoUsuariosPage = {
  __typename?: 'GrupoUsuariosPage'
  content?: Maybe<Array<Maybe<GrupoUsuarios>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type GruposUsuarioPermissoes = {
  __typename?: 'GruposUsuarioPermissoes'
  grupoUsuarios: GrupoUsuarios
  id: Scalars['ID']['output']
  permissaoAcessoPasta: BaseEnum
}

export type I18nLabel = {
  __typename?: 'I18nLabel'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export enum Idioma {
  En = 'EN',
  Es = 'ES',
  PtBr = 'PT_BR'
}

export type ImportStatus = {
  __typename?: 'ImportStatus'
  done?: Maybe<Scalars['Int']['output']>
  fileName?: Maybe<Scalars['String']['output']>
  progress?: Maybe<Scalars['Float']['output']>
  status?: Maybe<StatusFile>
  total?: Maybe<Scalars['Int']['output']>
}

export type InfoDealer = {
  __typename?: 'InfoDealer'
  divisao?: Maybe<Divisao>
  id: Scalars['ID']['output']
  setor?: Maybe<Setor>
}

export type InfoDealerInput = {
  divisaoId: Scalars['ID']['input']
  setorId: Scalars['ID']['input']
}

export type InfoUsuario = {
  __typename?: 'InfoUsuario'
  dataAdmissao?: Maybe<Scalars['Date']['output']>
  dataDesligamento?: Maybe<Scalars['Date']['output']>
  desligamento?: Maybe<Desligamento>
  emailSuperior?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type InfoUsuarioInput = {
  dataAdmissao: Scalars['Date']['input']
  dataDesligamento?: InputMaybe<Scalars['Date']['input']>
  desligamentoId?: InputMaybe<Scalars['ID']['input']>
  emailSuperior: Scalars['String']['input']
}

export type ItemBiblioteca = {
  __typename?: 'ItemBiblioteca'
  arquivo?: Maybe<Arquivo>
  arquivoImagem?: Maybe<Scalars['Boolean']['output']>
  arquivoLink?: Maybe<Scalars['String']['output']>
  arquivoMiniaturaLink?: Maybe<Scalars['String']['output']>
  breadcrumb?: Maybe<Array<Maybe<ItemBiblioteca>>>
  dataCriacao?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isPasta?: Maybe<Scalars['Boolean']['output']>
  isPublico?: Maybe<Scalars['Boolean']['output']>
  nome: Scalars['String']['output']
  pastaPai?: Maybe<ItemBiblioteca>
  permissoes?: Maybe<Array<Maybe<GruposUsuarioPermissoes>>>
  permissoesAcessoUsuarioLogado: Array<Maybe<BaseEnum>>
  proprietario?: Maybe<Usuario>
  ultimaModificacao?: Maybe<Scalars['DateTime']['output']>
}

export type ItemBibliotecaFilterInput = {
  busca?: InputMaybe<Scalars['String']['input']>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
}

export type ItemBibliotecaInput = {
  idArquivo: Scalars['ID']['input']
  idPastaPai: Scalars['ID']['input']
  nome?: InputMaybe<Scalars['String']['input']>
  /**
   *  valido apenas para arquivos
   *  sera criado um novo diretorio de acordo com caminho
   */
  relativePath?: InputMaybe<Scalars['String']['input']>
}

export type ItemBibliotecaPage = {
  __typename?: 'ItemBibliotecaPage'
  content?: Maybe<Array<Maybe<ItemBiblioteca>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

/**  Refers to ItemBiblioteca */
export type ItemDownload = {
  __typename?: 'ItemDownload'
  link: Scalars['String']['output']
  path: Scalars['String']['output']
}

export type ItemsPorPasta = {
  __typename?: 'ItemsPorPasta'
  content?: Maybe<Array<Maybe<ItemBiblioteca>>>
  totalFiles?: Maybe<Scalars['Int']['output']>
  totalFolders?: Maybe<Scalars['Int']['output']>
  totalItems?: Maybe<Scalars['Int']['output']>
}

export type LabelLanguageValue = {
  __typename?: 'LabelLanguageValue'
  id: Scalars['ID']['output']
  language?: Maybe<Idioma>
  value?: Maybe<Scalars['String']['output']>
}

export type LinkExterno = {
  __typename?: 'LinkExterno'
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  produto?: Maybe<Scalars['String']['output']>
  uri?: Maybe<Scalars['String']['output']>
  uriHomolog?: Maybe<Scalars['String']['output']>
}

export type LinksExternosInput = {
  id: Scalars['ID']['input']
  uriHomolog?: InputMaybe<Scalars['String']['input']>
}

export type Marca = {
  __typename?: 'Marca'
  description: Scalars['String']['output']
  facebookId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type Menu = {
  __typename?: 'Menu'
  active: Scalars['Boolean']['output']
  external?: Maybe<Scalars['Boolean']['output']>
  funcionalidades?: Maybe<Array<Maybe<Funcionalidade>>>
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  labels?: Maybe<Array<Maybe<LabelLanguageValue>>>
  parent: Menu
  uri?: Maybe<Scalars['String']['output']>
}

export type MenuInput = {
  active: Scalars['Boolean']['input']
  external?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  idParent: Scalars['ID']['input']
  idsFuncionalidades?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  idsLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  label?: InputMaybe<Scalars['String']['input']>
  uri?: InputMaybe<Scalars['String']['input']>
}

export type MenuUsuario = {
  __typename?: 'MenuUsuario'
  brandImageUrl?: Maybe<Scalars['String']['output']>
  currentProduct?: Maybe<Scalars['String']['output']>
  linkAcademia?: Maybe<Scalars['String']['output']>
  linkHelpTec?: Maybe<Scalars['String']['output']>
  linkPortal?: Maybe<Scalars['String']['output']>
  locales?: Maybe<Array<Maybe<BaseEnum>>>
  menus: Scalars['String']['output']
  productName?: Maybe<Scalars['String']['output']>
  theme?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type Modelo = {
  __typename?: 'Modelo'
  active: Scalars['Boolean']['output']
  agrupador: Agrupador
  codigo: Scalars['String']['output']
  descricao: Scalars['String']['output']
  id: Scalars['ID']['output']
  marca: Marca
  tipoMontagem: TipoMontagem
}

export type ModeloInput = {
  agrupador: Scalars['ID']['input']
  codigo: Scalars['String']['input']
  descricao: Scalars['String']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  marca: Scalars['String']['input']
  tipoMontagem: Scalars['ID']['input']
}

export type MotivoAusenciaTemporaria = {
  __typename?: 'MotivoAusenciaTemporaria'
  id?: Maybe<Scalars['ID']['output']>
  motivo?: Maybe<Scalars['String']['output']>
}

export type Mutation = {
  __typename?: 'Mutation'
  arquivarComunicadoEnvio?: Maybe<ComunicadoEnvio>
  ativarAgrupador?: Maybe<Agrupador>
  ativarAnuncio?: Maybe<Anuncio>
  ativarDealer?: Maybe<Dealer>
  ativarGrupo?: Maybe<Grupo>
  ativarGrupoUsuarios?: Maybe<GrupoUsuarios>
  ativarMenu?: Maybe<Menu>
  ativarModelo?: Maybe<Modelo>
  ativarSlide?: Maybe<Slide>
  ativarUsuario?: Maybe<Usuario>
  ativarVariacao?: Maybe<Variacao>
  /** GrupoUsuarios */
  atualizarGrupoFavorito?: Maybe<GrupoUsuarios>
  atualizarMinhaConta?: Maybe<Usuario>
  atualizarSenha?: Maybe<Scalars['Boolean']['output']>
  concederAcesso?: Maybe<ItemBiblioteca>
  /** biblioteca */
  criarNovaPasta?: Maybe<ItemBiblioteca>
  editarProduto?: Maybe<Scalars['Boolean']['output']>
  enviarComunicado?: Maybe<Comunicado>
  enviarComunicadoParaAprovacao?: Maybe<Comunicado>
  enviarNotificacaoGenerica: NotificacaoGenerica
  excluirItemBiblioteca?: Maybe<ItemBiblioteca>
  exportarDealers?: Maybe<Scalars['Boolean']['output']>
  exportarUsuarios?: Maybe<Scalars['Boolean']['output']>
  gerarLinkDownloadByItemBiblioteca?: Maybe<Scalars['String']['output']>
  /**  Push */
  gerarPushSubscription: Scalars['Boolean']['output']
  /**  SuperAdmin */
  importarGrupoUsuarios?: Maybe<Scalars['Boolean']['output']>
  inativarAgrupador?: Maybe<Agrupador>
  inativarAnuncio?: Maybe<Anuncio>
  inativarDealer?: Maybe<Dealer>
  inativarGrupo?: Maybe<Grupo>
  inativarGrupoUsuarios?: Maybe<GrupoUsuarios>
  inativarMenu?: Maybe<Menu>
  inativarModelo?: Maybe<Modelo>
  inativarSlide?: Maybe<Slide>
  inativarUsuario?: Maybe<Usuario>
  inativarVariacao?: Maybe<Variacao>
  /** FileUpload */
  linkDownloadByArquivo?: Maybe<Scalars['String']['output']>
  marcarComunicadoEnvioComoFavorito?: Maybe<ComunicadoEnvio>
  /** ComunicadoEnvio */
  marcarComunicadoEnvioComoLido?: Maybe<ComunicadoEnvio>
  marcarComunicadoEnvioComoNaoFavorito?: Maybe<ComunicadoEnvio>
  marcarComunicadoEnvioComoNaoLido?: Maybe<ComunicadoEnvio>
  /**  Notificacao */
  marcarNotificacoesComoVisualizadas: Scalars['Boolean']['output']
  moverItemBiblioteca?: Maybe<ItemBiblioteca>
  mudarLinguaUsuario?: Maybe<Usuario>
  rejeitarComunicado?: Maybe<Comunicado>
  removeAusenciaTemporaria?: Maybe<Scalars['Boolean']['output']>
  removerAnuncio?: Maybe<Scalars['ID']['output']>
  removerAtivacaoEspecialUsuario?: Maybe<Scalars['Boolean']['output']>
  removerComunicado?: Maybe<Comunicado>
  removerNotificacaoGenerica?: Maybe<Scalars['ID']['output']>
  removerSlide?: Maybe<Scalars['ID']['output']>
  renomearItemBiblioteca?: Maybe<ItemBiblioteca>
  resetarCacheLms?: Maybe<Scalars['Boolean']['output']>
  restaurarComunicadoEnvio?: Maybe<ComunicadoEnvio>
  /**  Modelos */
  salvarAgrupador?: Maybe<Agrupador>
  /**  Anuncio */
  salvarAnuncio?: Maybe<Anuncio>
  salvarAtivacaoEspecialUsuario?: Maybe<Scalars['Boolean']['output']>
  /**  Ausencia Temporaria */
  salvarAusenciaTemporaria?: Maybe<AusenciaTemporaria>
  /** Comunicado */
  salvarComunicado?: Maybe<Comunicado>
  /**  dealer */
  salvarDealer?: Maybe<Dealer>
  /**  grupo */
  salvarGrupo?: Maybe<Grupo>
  salvarGrupoUsuarios?: Maybe<GrupoUsuarios>
  /**  Menu */
  salvarMenu?: Maybe<Menu>
  salvarModelo?: Maybe<Modelo>
  salvarNotificacaoGenerica: NotificacaoGenerica
  /**  Slide */
  salvarSlide?: Maybe<Slide>
  /**  usuario */
  salvarUsuario?: Maybe<Usuario>
  salvarUsuarioLogado?: Maybe<Usuario>
  salvarVariacao?: Maybe<Variacao>
  /**  onboarding */
  setCurrentUserOnboardingSeen?: Maybe<Scalars['Boolean']['output']>
  sincronizarDealers?: Maybe<Scalars['Boolean']['output']>
  sincronizarGrupos?: Maybe<Scalars['Boolean']['output']>
  sincronizarIdentityProvider?: Maybe<Scalars['Boolean']['output']>
  sincronizarUsuarios?: Maybe<Scalars['Boolean']['output']>
  uploadArquivos?: Maybe<Array<Maybe<ItemBiblioteca>>>
}

export type MutationArquivarComunicadoEnvioArgs = {
  idComunicadoEnvio: Scalars['ID']['input']
}

export type MutationAtivarAgrupadorArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarAnuncioArgs = {
  idAnuncio: Scalars['ID']['input']
}

export type MutationAtivarDealerArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarGrupoArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarGrupoUsuariosArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarMenuArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarModeloArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarSlideArgs = {
  idSlide: Scalars['ID']['input']
}

export type MutationAtivarUsuarioArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarVariacaoArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtualizarGrupoFavoritoArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtualizarMinhaContaArgs = {
  usuario: AtualizarMinhaContaInput
}

export type MutationAtualizarSenhaArgs = {
  id: Scalars['ID']['input']
}

export type MutationConcederAcessoArgs = {
  novasPermissoes: ConcederAcessoInput
}

export type MutationCriarNovaPastaArgs = {
  novaPasta: NovaPastaInput
}

export type MutationEditarProdutoArgs = {
  produto: ProdutoInput
}

export type MutationEnviarComunicadoArgs = {
  idComunicado: Scalars['ID']['input']
}

export type MutationEnviarComunicadoParaAprovacaoArgs = {
  idComunicado: Scalars['ID']['input']
  idUsuarioAprovador: Scalars['ID']['input']
}

export type MutationEnviarNotificacaoGenericaArgs = {
  idNotificacaoGenerica: Scalars['ID']['input']
}

export type MutationExcluirItemBibliotecaArgs = {
  idItem: Scalars['ID']['input']
}

export type MutationExportarDealersArgs = {
  filtro: DealerFilterInput
}

export type MutationExportarUsuariosArgs = {
  filtro: UsuarioFilterInput
}

export type MutationGerarLinkDownloadByItemBibliotecaArgs = {
  idItemBiblioteca: Scalars['ID']['input']
}

export type MutationGerarPushSubscriptionArgs = {
  pushSubscriptionInput: PushSubscriptionInput
}

export type MutationInativarAgrupadorArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarAnuncioArgs = {
  idAnuncio: Scalars['ID']['input']
}

export type MutationInativarDealerArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarGrupoArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarGrupoUsuariosArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarMenuArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarModeloArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarSlideArgs = {
  idSlide: Scalars['ID']['input']
}

export type MutationInativarUsuarioArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarVariacaoArgs = {
  id: Scalars['ID']['input']
}

export type MutationLinkDownloadByArquivoArgs = {
  idArquivo: Scalars['ID']['input']
  registrarDownload: Scalars['Boolean']['input']
}

export type MutationMarcarComunicadoEnvioComoFavoritoArgs = {
  idComunicadoEnvio: Scalars['ID']['input']
}

export type MutationMarcarComunicadoEnvioComoLidoArgs = {
  idComunicadoEnvio: Scalars['ID']['input']
}

export type MutationMarcarComunicadoEnvioComoNaoFavoritoArgs = {
  idComunicadoEnvio: Scalars['ID']['input']
}

export type MutationMarcarComunicadoEnvioComoNaoLidoArgs = {
  idComunicadoEnvio: Scalars['ID']['input']
}

export type MutationMoverItemBibliotecaArgs = {
  idItemBiblioteca: Scalars['ID']['input']
  idNovaLocalizacao: Scalars['ID']['input']
}

export type MutationMudarLinguaUsuarioArgs = {
  id: Scalars['ID']['input']
  idioma: Idioma
}

export type MutationRejeitarComunicadoArgs = {
  idComunicado: Scalars['ID']['input']
  motivoRejeicao: Scalars['String']['input']
}

export type MutationRemoveAusenciaTemporariaArgs = {
  id: Scalars['ID']['input']
}

export type MutationRemoverAnuncioArgs = {
  idAnuncio: Scalars['ID']['input']
}

export type MutationRemoverAtivacaoEspecialUsuarioArgs = {
  idUsuario: Scalars['ID']['input']
}

export type MutationRemoverComunicadoArgs = {
  idComunicado: Scalars['ID']['input']
}

export type MutationRemoverNotificacaoGenericaArgs = {
  idNotificacaoGenerica: Scalars['ID']['input']
}

export type MutationRemoverSlideArgs = {
  idSlide: Scalars['ID']['input']
}

export type MutationRenomearItemBibliotecaArgs = {
  idItemBiblioteca: Scalars['ID']['input']
  novoNome: Scalars['String']['input']
}

export type MutationRestaurarComunicadoEnvioArgs = {
  idComunicadoEnvio: Scalars['ID']['input']
}

export type MutationSalvarAgrupadorArgs = {
  agrupador: AgrupadorInput
}

export type MutationSalvarAnuncioArgs = {
  anuncioInput: AnuncioInput
}

export type MutationSalvarAtivacaoEspecialUsuarioArgs = {
  ativacaoEspecialUsuario: AtivacaoEspecialUsuarioInput
}

export type MutationSalvarAusenciaTemporariaArgs = {
  input?: InputMaybe<AusenciaTemporariaInput>
}

export type MutationSalvarComunicadoArgs = {
  comunicadoInput: ComunicadoInput
}

export type MutationSalvarDealerArgs = {
  dealer: DealerInput
  infos?: InputMaybe<InfoDealerInput>
}

export type MutationSalvarGrupoArgs = {
  grupo: GrupoInput
}

export type MutationSalvarGrupoUsuariosArgs = {
  grupoUsuarios: GrupoUsuariosInput
}

export type MutationSalvarMenuArgs = {
  menu: MenuInput
}

export type MutationSalvarModeloArgs = {
  modelo: ModeloInput
}

export type MutationSalvarNotificacaoGenericaArgs = {
  notificacaoGenericaInput: NotificacaoGenericaInput
}

export type MutationSalvarSlideArgs = {
  slideInput: SlideInput
}

export type MutationSalvarUsuarioArgs = {
  cargos: Array<InputMaybe<CargoInput>>
  infos?: InputMaybe<InfoUsuarioInput>
  usuario: UsuarioInput
}

export type MutationSalvarUsuarioLogadoArgs = {
  usuarioLogado: UsuarioInput
}

export type MutationSalvarVariacaoArgs = {
  variacao: VariacaoInput
}

export type MutationSetCurrentUserOnboardingSeenArgs = {
  id: Scalars['ID']['input']
}

export type MutationSincronizarIdentityProviderArgs = {
  emailUsuario: Scalars['String']['input']
}

export type MutationUploadArquivosArgs = {
  arquivos: Array<ItemBibliotecaInput>
}

export type Node = Grupo | Usuario

export type Notificacao = {
  __typename?: 'Notificacao'
  active: Scalars['Boolean']['output']
  chave: Scalars['String']['output']
  createdDateTime: Scalars['DateTime']['output']
  descricao: Scalars['String']['output']
  emailBadgeTitle: Scalars['String']['output']
  emailButtonLabel: Scalars['String']['output']
  emailButtonMessage: Scalars['String']['output']
  emailNomeFrom: Scalars['String']['output']
  id: Scalars['ID']['output']
  padrao: Scalars['Boolean']['output']
  produto: Produto
  tipos: Array<Maybe<BaseEnum>>
}

export type NotificacaoGenerica = {
  __typename?: 'NotificacaoGenerica'
  active: Scalars['Boolean']['output']
  agendamentoDateTime?: Maybe<Scalars['DateTime']['output']>
  createdDateTime: Scalars['DateTime']['output']
  envioDateTime?: Maybe<Scalars['DateTime']['output']>
  grupos?: Maybe<Array<GrupoUsuarios>>
  id: Scalars['ID']['output']
  link?: Maybe<Scalars['String']['output']>
  modelo: Scalars['Boolean']['output']
  produto: Produto
  texto: Scalars['String']['output']
  titulo: Scalars['String']['output']
  usuario: Usuario
}

export type NotificacaoGenericaFilterInput = {
  agendada: Scalars['Boolean']['input']
  conteudo?: InputMaybe<Scalars['String']['input']>
  dataAgendamentoFinal?: InputMaybe<Scalars['DateTime']['input']>
  dataAgendamentoInicial?: InputMaybe<Scalars['DateTime']['input']>
  dataCriacaoFinal?: InputMaybe<Scalars['DateTime']['input']>
  dataCriacaoInicial?: InputMaybe<Scalars['DateTime']['input']>
  dataEnvioFinal?: InputMaybe<Scalars['DateTime']['input']>
  dataEnvioInicial?: InputMaybe<Scalars['DateTime']['input']>
  enviada: Scalars['Boolean']['input']
  idsProdutos?: InputMaybe<Array<Scalars['ID']['input']>>
  modelo: Scalars['Boolean']['input']
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
}

export type NotificacaoGenericaInput = {
  agendamentoDateTime?: InputMaybe<Scalars['DateTime']['input']>
  idNotificacaoGenerica?: InputMaybe<Scalars['ID']['input']>
  idProduto: Scalars['Int']['input']
  idsGrupos: Array<Scalars['Int']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  modelo: Scalars['Boolean']['input']
  texto: Scalars['String']['input']
  titulo: Scalars['String']['input']
}

export type NotificacaoGenericaPage = {
  __typename?: 'NotificacaoGenericaPage'
  content?: Maybe<Array<Maybe<NotificacaoGenerica>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type NotificacaoItem = {
  __typename?: 'NotificacaoItem'
  createdDateTime: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  link?: Maybe<Scalars['String']['output']>
  produto: Produto
  texto: Scalars['String']['output']
  titulo: Scalars['String']['output']
}

export type NotificacaoItemUsuario = {
  __typename?: 'NotificacaoItemUsuario'
  id: Scalars['ID']['output']
  notificacaoItem: NotificacaoItem
  tipo: BaseEnum
  usuario: Usuario
  visualizacaoDateTime?: Maybe<Scalars['DateTime']['output']>
}

export type NotificacaoItemUsuarioFilterInput = {
  conteudo?: InputMaybe<Scalars['String']['input']>
  dataFinal?: InputMaybe<Scalars['DateTime']['input']>
  dataInicial?: InputMaybe<Scalars['DateTime']['input']>
  idsProdutos?: InputMaybe<Array<Scalars['ID']['input']>>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
}

export type NotificacaoItemUsuarioPage = {
  __typename?: 'NotificacaoItemUsuarioPage'
  content?: Maybe<Array<Maybe<NotificacaoItemUsuario>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type NotificacaoMenu = {
  __typename?: 'NotificacaoMenu'
  data: Scalars['String']['output']
  id: Scalars['ID']['output']
  link?: Maybe<Scalars['String']['output']>
  produto: Scalars['String']['output']
  recente: Scalars['Boolean']['output']
  texto: Scalars['String']['output']
  titulo: Scalars['String']['output']
}

export type NotificacaoUsuario = {
  __typename?: 'NotificacaoUsuario'
  enabled: Scalars['Boolean']['output']
  notificacao: Notificacao
  tipo: BaseEnum
  usuario: Usuario
}

export type NotificacaoUsuarioInput = {
  chaveNotificacao: Scalars['String']['input']
  tipoNotificacao: Scalars['String']['input']
}

export type NovaPastaInput = {
  idPai?: InputMaybe<Scalars['ID']['input']>
  idsGrupoAcesso?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  nome: Scalars['String']['input']
  tiposAcesso: Array<InputMaybe<TipoAcessoInput>>
}

export type Page = {
  __typename?: 'Page'
  hasNext: Scalars['Boolean']['output']
  nodes: Array<Maybe<Node>>
  page: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
}

export type PodeAdicionarCargoInput = {
  cargoAdicionadoInput: CargoInput
  cargosInputs: Array<InputMaybe<CargoInput>>
}

export type Produto = {
  __typename?: 'Produto'
  baseUri: Scalars['String']['output']
  baseUriHomolog: Scalars['String']['output']
  chave: Scalars['String']['output']
  funcionalidades?: Maybe<Array<Maybe<Funcionalidade>>>
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
  ordem?: Maybe<Scalars['Int']['output']>
  tiposAcesso?: Maybe<Array<Maybe<TipoAcesso>>>
}

export type ProdutoInput = {
  baseUriHomolog?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  linksExternos?: InputMaybe<Array<InputMaybe<LinksExternosInput>>>
}

export type ProdutosInput = {
  idProduto: Scalars['ID']['input']
  idsFuncionalidades: Array<Scalars['ID']['input']>
  idsTiposAcesso: Array<Scalars['ID']['input']>
}

export type PushSubscriptionInput = {
  auth: Scalars['String']['input']
  endpoint: Scalars['String']['input']
  key: Scalars['String']['input']
}

export type Query = {
  __typename?: 'Query'
  agrupador?: Maybe<Agrupador>
  agrupadores: Array<Maybe<Agrupador>>
  /**  Modelos */
  agrupadoresByDescricao: Array<Maybe<Agrupador>>
  anuncio?: Maybe<Anuncio>
  anuncioAleatorio?: Maybe<Anuncio>
  /**  Anuncio */
  anuncios?: Maybe<Array<Maybe<Anuncio>>>
  anunciosPaged?: Maybe<AnuncioPage>
  arquivo?: Maybe<Arquivo>
  /**  Ativacao Especial */
  ativacaoEspecialUsuarioByUsuarioId?: Maybe<AtivacaoEspecialUsuario>
  /**  Auditoria */
  auditoria?: Maybe<Array<Maybe<RevisionDiff>>>
  /**  Ausencia Temporaria */
  ausenciaTemporaria?: Maybe<AusenciaTemporaria>
  ausenciasTemporarias?: Maybe<Array<Maybe<AusenciaTemporaria>>>
  buscaBiblioteca?: Maybe<Array<Maybe<ItemBiblioteca>>>
  buscaBibliotecaPaged?: Maybe<ItemBibliotecaPage>
  buscaComunicadoEnvios?: Maybe<Array<Maybe<ComunicadoEnvio>>>
  /**  Cargos */
  cargos?: Maybe<Array<Maybe<Cargo>>>
  comunicado?: Maybe<Comunicado>
  /**  Comunicado */
  comunicadoDashboard?: Maybe<ComunicadoDashboard>
  comunicadoEnvio?: Maybe<ComunicadoEnvio>
  /**  Comunicado Envio */
  comunicadoEnvios?: Maybe<Array<Maybe<ComunicadoEnvio>>>
  comunicadoEnviosArquivados?: Maybe<Array<Maybe<ComunicadoEnvio>>>
  comunicadoEnviosPaged?: Maybe<ComunicadoEnvioPage>
  comunicadoEnviosRecentes?: Maybe<Array<Maybe<ComunicadoEnvio>>>
  comunicadoPreview?: Maybe<Scalars['String']['output']>
  comunicadoSequenciamento?: Maybe<Scalars['String']['output']>
  comunicadoTemplates: Array<TemplateOption>
  comunicadoUsuarios?: Maybe<Array<Maybe<Usuario>>>
  comunicadoUsuariosAprovadores?: Maybe<Array<Maybe<Usuario>>>
  comunicados?: Maybe<Array<Maybe<Comunicado>>>
  comunicadosPaged?: Maybe<ComunicadoPage>
  comunicadosParaAprovacao?: Maybe<Array<Maybe<Comunicado>>>
  countNotificacoesNaoLidas?: Maybe<Scalars['Int']['output']>
  /**  Onboarding */
  currentUserOnboardingIsSeen?: Maybe<Scalars['Boolean']['output']>
  dealer?: Maybe<Dealer>
  dealerByCNPJ?: Maybe<Dealer>
  dealerByCodigo?: Maybe<Dealer>
  /**  Dealer */
  dealers?: Maybe<Array<Maybe<Dealer>>>
  dealersByGrupo?: Maybe<Array<Maybe<Dealer>>>
  dealersPaged?: Maybe<DealerPage>
  departamentos?: Maybe<Array<Maybe<Departamento>>>
  /**  Departamento */
  departamentosCargosUsuarios?: Maybe<Array<Maybe<Departamento>>>
  departamentosComunicados?: Maybe<Array<Maybe<Departamento>>>
  /**  Desligamento */
  desligamentos?: Maybe<Array<Maybe<Desligamento>>>
  /**  Divisao */
  divisoes?: Maybe<Array<Maybe<Divisao>>>
  /** # ItemBblioteca IDs */
  downloadBatch: Array<ItemDownload>
  /**  CEP */
  endereco?: Maybe<EnderecoCep>
  estados?: Maybe<Array<Maybe<BaseEnum>>>
  /**  Etiqueta */
  etiquetas?: Maybe<Array<Maybe<Etiqueta>>>
  etiquetasByNomeStartingWith?: Maybe<Array<Maybe<Etiqueta>>>
  existemUsuariosEmGrupos?: Maybe<Scalars['Boolean']['output']>
  /**  Funcionalidade */
  funcionalidades?: Maybe<Array<Maybe<Funcionalidade>>>
  grupo?: Maybe<Grupo>
  grupoByNome?: Maybe<Grupo>
  grupoUsuarios?: Maybe<GrupoUsuarios>
  grupoUsuariosByNome?: Maybe<GrupoUsuarios>
  grupos?: Maybe<Array<Maybe<Grupo>>>
  gruposAtivos?: Maybe<Array<Maybe<Grupo>>>
  /**  Grupo */
  gruposPaged?: Maybe<GrupoPage>
  /**  Grupo de Usuarios */
  gruposUsuarios?: Maybe<Array<Maybe<GrupoUsuarios>>>
  gruposUsuariosAtivos?: Maybe<Array<Maybe<GrupoUsuarios>>>
  gruposUsuariosPaged?: Maybe<GrupoUsuariosPage>
  /**  i18n Labels */
  i18nLabels: Array<I18nLabel>
  /**  Enums */
  idiomas?: Maybe<Array<Maybe<BaseEnum>>>
  /**  Importacao */
  importStatus?: Maybe<Array<Maybe<ImportStatus>>>
  /**  Informacoes Adicionais */
  infoDealer?: Maybe<InfoDealer>
  infoUsuario?: Maybe<InfoUsuario>
  /**  Biblioteca */
  itemsPorPasta?: Maybe<ItemsPorPasta>
  /**
   *  Layout Dinamico
   *  retornando JSON devido a limitação do graphql (https://github.com/graphql/graphql-spec/issues/91)
   */
  layout: Scalars['String']['output']
  /**  Arquivo */
  linkDownloadByArquivo?: Maybe<Scalars['String']['output']>
  linksExternosByProduto?: Maybe<Array<Maybe<LinkExterno>>>
  marcas?: Maybe<Array<Maybe<BaseEnum>>>
  menuUsuarioLogado: MenuUsuario
  /**  Menu */
  menus?: Maybe<Array<Maybe<Menu>>>
  modelo?: Maybe<Modelo>
  modelos: Array<Maybe<Modelo>>
  modelosByCodigo: Array<Maybe<Modelo>>
  modelosByDescricao: Array<Maybe<Modelo>>
  motivosAusenciaTemporaria?: Maybe<Array<Maybe<MotivoAusenciaTemporaria>>>
  notificacaoGenerica: NotificacaoGenerica
  notificacaoItensUsuario?: Maybe<NotificacaoItemUsuarioPage>
  notificacaoProdutosUsuario?: Maybe<Array<Maybe<Produto>>>
  notificacaoTipos?: Maybe<Array<Maybe<BaseEnum>>>
  /**  Notificacao */
  notificacoesDisponiveisUsuario?: Maybe<Array<Maybe<Notificacao>>>
  notificacoesGenericas?: Maybe<NotificacaoGenericaPage>
  notificacoesMenu?: Maybe<Array<Maybe<NotificacaoMenu>>>
  pasta?: Maybe<ItemBiblioteca>
  pastasComPermissaoEscrita?: Maybe<Array<Maybe<ItemBiblioteca>>>
  permissoesPorTipoUsuario?: Maybe<Array<Maybe<TipoAcesso>>>
  podeAdicionarCargo?: Maybe<Scalars['Boolean']['output']>
  /**  Produtos */
  produtos?: Maybe<Array<Maybe<Produto>>>
  produtosByDealersAndTipoUsuario?: Maybe<Array<Maybe<Produto>>>
  produtosSemPortal?: Maybe<Array<Maybe<Produto>>>
  propriedadesPortal?: Maybe<Array<Maybe<BaseEnum>>>
  quantidadeComunicadoEnviosNaoLidos?: Maybe<Scalars['Int']['output']>
  /**  Rede Social */
  redesSociais?: Maybe<Array<Maybe<RedeSocial>>>
  /**  Relatorio */
  relatorio?: Maybe<Relatorio>
  /**  Setores */
  setores?: Maybe<Array<Maybe<Setor>>>
  slide?: Maybe<Slide>
  /**  Slide */
  slides?: Maybe<Array<Maybe<Slide>>>
  slidesAtivos?: Maybe<Array<Maybe<Slide>>>
  slidesPaged?: Maybe<SlidePage>
  tiposMontagem: Array<Maybe<TipoMontagem>>
  tiposUsuario?: Maybe<Array<Maybe<BaseEnum>>>
  ultimosModificados?: Maybe<Array<Maybe<ItemBiblioteca>>>
  usuario?: Maybe<Usuario>
  usuarioByCpf?: Maybe<Usuario>
  usuarioByEmail?: Maybe<Usuario>
  /**  Usuario */
  usuarioLogado?: Maybe<Usuario>
  usuarios?: Maybe<Array<Maybe<Usuario>>>
  usuariosByGruposUsuariosPaged?: Maybe<UsuarioPage>
  usuariosByNomeOrEmailStartingWith?: Maybe<Array<Maybe<Usuario>>>
  usuariosByTipoUsuario?: Maybe<Array<Maybe<Usuario>>>
  usuariosPaged?: Maybe<UsuarioPage>
  /**  Properties */
  usuariosPortalProperties: UsuariosPortalProperties
  variacao?: Maybe<Variacao>
  variacoes: Array<Maybe<Variacao>>
  variacoesByCodigo: Array<Maybe<Variacao>>
}

export type QueryAgrupadorArgs = {
  id: Scalars['ID']['input']
}

export type QueryAgrupadoresByDescricaoArgs = {
  descricao: Scalars['String']['input']
}

export type QueryAnuncioArgs = {
  idAnuncio: Scalars['ID']['input']
}

export type QueryAnunciosPagedArgs = {
  filterInput?: InputMaybe<AnuncioFilterInput>
}

export type QueryArquivoArgs = {
  idArquivo: Scalars['ID']['input']
}

export type QueryAtivacaoEspecialUsuarioByUsuarioIdArgs = {
  usuarioId: Scalars['ID']['input']
}

export type QueryAuditoriaArgs = {
  id: Scalars['ID']['input']
  tipo: Scalars['String']['input']
}

export type QueryAusenciaTemporariaArgs = {
  id: Scalars['ID']['input']
}

export type QueryAusenciasTemporariasArgs = {
  usuarioId: Scalars['ID']['input']
}

export type QueryBuscaBibliotecaArgs = {
  texto?: InputMaybe<Scalars['String']['input']>
}

export type QueryBuscaBibliotecaPagedArgs = {
  filterInput?: InputMaybe<ItemBibliotecaFilterInput>
}

export type QueryBuscaComunicadoEnviosArgs = {
  texto?: InputMaybe<Scalars['String']['input']>
}

export type QueryCargosArgs = {
  cargosPrincipais?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  usuarioId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryComunicadoArgs = {
  idComunicado: Scalars['ID']['input']
  isErrataContext?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryComunicadoDashboardArgs = {
  idComunicado: Scalars['ID']['input']
}

export type QueryComunicadoEnvioArgs = {
  idComunicado: Scalars['ID']['input']
}

export type QueryComunicadoEnviosPagedArgs = {
  filterInput?: InputMaybe<ComunicadoEnvioFilterInput>
}

export type QueryComunicadoPreviewArgs = {
  conteudo: Scalars['String']['input']
  rodape?: InputMaybe<Scalars['String']['input']>
  templateName?: InputMaybe<Scalars['String']['input']>
  titulo: Scalars['String']['input']
}

export type QueryComunicadoSequenciamentoArgs = {
  idDepartamento: Scalars['ID']['input']
}

export type QueryComunicadoUsuariosArgs = {
  idsGrupos?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryComunicadosPagedArgs = {
  filterInput?: InputMaybe<ComunicadoFilterInput>
}

export type QueryCurrentUserOnboardingIsSeenArgs = {
  id: Scalars['ID']['input']
}

export type QueryDealerArgs = {
  id: Scalars['ID']['input']
}

export type QueryDealerByCnpjArgs = {
  cnpj: Scalars['String']['input']
}

export type QueryDealerByCodigoArgs = {
  codigo: Scalars['String']['input']
}

export type QueryDealersByGrupoArgs = {
  grupoId: Scalars['ID']['input']
}

export type QueryDealersPagedArgs = {
  filterInput?: InputMaybe<DealerFilterInput>
}

export type QueryDownloadBatchArgs = {
  ids: Array<Scalars['ID']['input']>
}

export type QueryEnderecoArgs = {
  cep: Scalars['String']['input']
}

export type QueryEtiquetasByNomeStartingWithArgs = {
  nome: Scalars['String']['input']
}

export type QueryExistemUsuariosEmGruposArgs = {
  grupos?: InputMaybe<Array<GrupoUsuariosInput>>
}

export type QueryGrupoArgs = {
  id: Scalars['ID']['input']
}

export type QueryGrupoByNomeArgs = {
  nome: Scalars['String']['input']
}

export type QueryGrupoUsuariosArgs = {
  id: Scalars['ID']['input']
}

export type QueryGrupoUsuariosByNomeArgs = {
  nome: Scalars['String']['input']
}

export type QueryGruposPagedArgs = {
  filterInput?: InputMaybe<GrupoFilterInput>
}

export type QueryGruposUsuariosPagedArgs = {
  filterInput?: InputMaybe<GrupoUsuariosFilterInput>
}

export type QueryInfoDealerArgs = {
  dealerId: Scalars['ID']['input']
}

export type QueryInfoUsuarioArgs = {
  usuarioId: Scalars['ID']['input']
}

export type QueryItemsPorPastaArgs = {
  idPastaPai?: InputMaybe<Scalars['ID']['input']>
}

export type QueryLayoutArgs = {
  viewId: Scalars['String']['input']
}

export type QueryLinkDownloadByArquivoArgs = {
  idArquivo: Scalars['ID']['input']
}

export type QueryLinksExternosByProdutoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryModeloArgs = {
  id: Scalars['ID']['input']
}

export type QueryModelosByCodigoArgs = {
  codigo: Scalars['String']['input']
}

export type QueryModelosByDescricaoArgs = {
  descricao: Scalars['String']['input']
}

export type QueryNotificacaoGenericaArgs = {
  idNotificacaoGenerica: Scalars['ID']['input']
}

export type QueryNotificacaoItensUsuarioArgs = {
  filterInput: NotificacaoItemUsuarioFilterInput
}

export type QueryNotificacoesGenericasArgs = {
  filterInput: NotificacaoGenericaFilterInput
}

export type QueryPastaArgs = {
  idPasta?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPermissoesPorTipoUsuarioArgs = {
  produtos?: InputMaybe<Array<Scalars['String']['input']>>
  tipoUsuario: Scalars['String']['input']
}

export type QueryPodeAdicionarCargoArgs = {
  podeAdicionarCargoInput?: InputMaybe<PodeAdicionarCargoInput>
}

export type QueryProdutosByDealersAndTipoUsuarioArgs = {
  idsDealer?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  tipoUsuario: Scalars['ID']['input']
}

export type QueryRedesSociaisArgs = {
  marca: Scalars['String']['input']
}

export type QueryRelatorioArgs = {
  slug: Scalars['String']['input']
}

export type QuerySetoresArgs = {
  divisaoId?: InputMaybe<Scalars['ID']['input']>
}

export type QuerySlideArgs = {
  idSlide: Scalars['ID']['input']
}

export type QuerySlidesPagedArgs = {
  filterInput?: InputMaybe<SlideFilterInput>
}

export type QueryUsuarioArgs = {
  id: Scalars['ID']['input']
}

export type QueryUsuarioByCpfArgs = {
  cpf: Scalars['String']['input']
}

export type QueryUsuarioByEmailArgs = {
  email: Scalars['String']['input']
}

export type QueryUsuariosByGruposUsuariosPagedArgs = {
  filterInput?: InputMaybe<UsuariosByGruposUsuariosFilterInput>
}

export type QueryUsuariosByNomeOrEmailStartingWithArgs = {
  nome: Scalars['String']['input']
}

export type QueryUsuariosByTipoUsuarioArgs = {
  busca?: InputMaybe<Scalars['String']['input']>
  dealerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  tipo: Scalars['String']['input']
}

export type QueryUsuariosPagedArgs = {
  filterInput?: InputMaybe<UsuarioFilterInput>
}

export type QueryVariacaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryVariacoesByCodigoArgs = {
  codigo: Scalars['String']['input']
}

export type RedeSocial = {
  __typename?: 'RedeSocial'
  icone: Scalars['String']['output']
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Relatorio = {
  __typename?: 'Relatorio'
  embedToken: Scalars['String']['output']
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
}

export type RevisionDiff = {
  __typename?: 'RevisionDiff'
  dataHoraFormatada: Scalars['String']['output']
  diffs?: Maybe<Array<RevisionDiffItem>>
  usuario: Usuario
}

export type RevisionDiffItem = {
  __typename?: 'RevisionDiffItem'
  newValue?: Maybe<Scalars['String']['output']>
  oldValue?: Maybe<Scalars['String']['output']>
  propertyKey: Scalars['String']['output']
  propertyLabel: Scalars['String']['output']
  typeAsString: Scalars['String']['output']
}

export type Setor = {
  __typename?: 'Setor'
  divisao?: Maybe<Divisao>
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
}

export type Slide = {
  __typename?: 'Slide'
  active: Scalars['Boolean']['output']
  arquivo: Arquivo
  corSubtitulo: Scalars['String']['output']
  corTitulo: Scalars['String']['output']
  createdDateTime: Scalars['DateTime']['output']
  emExibicao: Scalars['Boolean']['output']
  fimDate?: Maybe<Scalars['Date']['output']>
  grupos?: Maybe<Array<GrupoUsuarios>>
  id: Scalars['ID']['output']
  inicioDate?: Maybe<Scalars['Date']['output']>
  link?: Maybe<Scalars['String']['output']>
  linkTarget?: Maybe<Scalars['String']['output']>
  subtitulo: Scalars['String']['output']
  tamanhoSubtitulo: Scalars['Int']['output']
  tamanhoTitulo: Scalars['Int']['output']
  titulo: Scalars['String']['output']
  tituloBotao?: Maybe<Scalars['String']['output']>
}

export type SlideFilterInput = {
  dataFinal?: InputMaybe<Scalars['Date']['input']>
  dataInicial?: InputMaybe<Scalars['Date']['input']>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
  somenteAtivos?: InputMaybe<Scalars['Boolean']['input']>
  somenteEmExibicao?: InputMaybe<Scalars['Boolean']['input']>
  titulo?: InputMaybe<Scalars['String']['input']>
}

export type SlideInput = {
  corSubtitulo: Scalars['String']['input']
  corTitulo: Scalars['String']['input']
  fimDate?: InputMaybe<Scalars['Date']['input']>
  idArquivo: Scalars['ID']['input']
  idSlide?: InputMaybe<Scalars['ID']['input']>
  idsGrupos?: InputMaybe<Array<Scalars['ID']['input']>>
  inicioDate?: InputMaybe<Scalars['Date']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  linkTarget?: InputMaybe<Scalars['String']['input']>
  subtitulo: Scalars['String']['input']
  tamanhoSubtitulo: Scalars['String']['input']
  tamanhoTitulo: Scalars['Int']['input']
  titulo: Scalars['String']['input']
  tituloBotao?: InputMaybe<Scalars['String']['input']>
}

export type SlidePage = {
  __typename?: 'SlidePage'
  content?: Maybe<Array<Maybe<Slide>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type StatusEmailEnum = {
  __typename?: 'StatusEmailEnum'
  descricao?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export enum StatusFile {
  Error = 'ERROR',
  Processing = 'PROCESSING',
  Received = 'RECEIVED'
}

export type TemplateOption = {
  __typename?: 'TemplateOption'
  description: Scalars['String']['output']
  isDefault: Scalars['Boolean']['output']
  templateName: Scalars['String']['output']
}

export type TipoAcesso = {
  __typename?: 'TipoAcesso'
  chave: Scalars['String']['output']
  funcionalidadesPadrao?: Maybe<Array<Maybe<Funcionalidade>>>
  id: Scalars['ID']['output']
  nome: Scalars['String']['output']
  produto: Produto
  tiposUsuario?: Maybe<Array<Maybe<BaseEnum>>>
}

export type TipoAcessoInput = {
  idGrupoAcesso: Scalars['ID']['input']
  permissao: Scalars['ID']['input']
}

export type TipoMontagem = {
  __typename?: 'TipoMontagem'
  active: Scalars['Boolean']['output']
  chave: Scalars['String']['output']
  descricao: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type Usuario = {
  __typename?: 'Usuario'
  active?: Maybe<Scalars['Boolean']['output']>
  ativacaoEspecial: Scalars['Boolean']['output']
  ausenteTemporariamente: Scalars['Boolean']['output']
  avatar?: Maybe<Arquivo>
  avatarLink?: Maybe<Scalars['String']['output']>
  celulares?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  cpf?: Maybe<Scalars['String']['output']>
  dadosComplementares: Array<Maybe<DadoComplementar>>
  dealers?: Maybe<Array<Maybe<Dealer>>>
  email?: Maybe<Scalars['String']['output']>
  especial: Scalars['Boolean']['output']
  funcionalidades?: Maybe<Array<Maybe<Funcionalidade>>>
  grupos?: Maybe<Array<Maybe<Grupo>>>
  gruposUsuarios: Array<GrupoUsuarios>
  id: Scalars['ID']['output']
  idioma?: Maybe<BaseEnum>
  isEstrangeiro?: Maybe<Scalars['Boolean']['output']>
  keycloakId?: Maybe<Scalars['String']['output']>
  marcas?: Maybe<Array<Maybe<Marca>>>
  menuOnboardingSeen?: Maybe<Scalars['Boolean']['output']>
  nome?: Maybe<Scalars['String']['output']>
  notificacoesUsuario?: Maybe<Array<Maybe<NotificacaoUsuario>>>
  produtos: Array<Produto>
  telefones?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  tipo?: Maybe<BaseEnum>
  tipoDocumento?: Maybe<BaseEnum>
  tiposAcesso?: Maybe<Array<Maybe<TipoAcesso>>>
  tiposUsuarios: Array<BaseEnum>
}

export type UsuarioFilterInput = {
  busca?: InputMaybe<Scalars['String']['input']>
  idsCargos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  idsDealers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  idsDepartamentos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  idsProdutos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  page: Scalars['Int']['input']
  permissoes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  rowsPerPage: Scalars['Int']['input']
  somenteAtivos?: InputMaybe<Scalars['Boolean']['input']>
  tipoUsuario?: InputMaybe<Scalars['String']['input']>
}

export type UsuarioInput = {
  celulares?: InputMaybe<Array<Scalars['String']['input']>>
  cpf?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  idioma?: InputMaybe<Scalars['ID']['input']>
  idsDealers?: InputMaybe<Array<Scalars['ID']['input']>>
  marcas?: InputMaybe<Array<Scalars['ID']['input']>>
  nome: Scalars['String']['input']
  notificacoesUsuario?: InputMaybe<Array<InputMaybe<NotificacaoUsuarioInput>>>
  produtos?: InputMaybe<Array<InputMaybe<ProdutosInput>>>
  telefones?: InputMaybe<Array<Scalars['String']['input']>>
  tipo: Scalars['ID']['input']
  tipoDocumento: Scalars['ID']['input']
}

export type UsuarioPage = {
  __typename?: 'UsuarioPage'
  content?: Maybe<Array<Maybe<Usuario>>>
  totalElements?: Maybe<Scalars['Int']['output']>
}

export type UsuariosByGruposUsuariosFilterInput = {
  busca?: InputMaybe<Scalars['String']['input']>
  grupos?: InputMaybe<Array<GrupoUsuariosInput>>
  page: Scalars['Int']['input']
  rowsPerPage: Scalars['Int']['input']
}

export type UsuariosPortalProperties = {
  __typename?: 'UsuariosPortalProperties'
  informarDepartamentoCargo: Scalars['Boolean']['output']
  tiposUsuarioDocumentoObrigatorio: Array<Maybe<BaseEnum>>
  tiposUsuarioInformarCargo: Array<Maybe<BaseEnum>>
  tiposUsuarioInformarGestao: Array<Maybe<BaseEnum>>
}

export type Variacao = {
  __typename?: 'Variacao'
  active: Scalars['Boolean']['output']
  codigo: Scalars['String']['output']
  descricao?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  modelos: Array<Maybe<Modelo>>
}

export type VariacaoInput = {
  codigo: Scalars['String']['input']
  descricao?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  modelos: Array<InputMaybe<Scalars['ID']['input']>>
}

export type LinkDownloadByArquivoQueryQueryVariables = Exact<{
  idArquivo: Scalars['ID']['input']
}>

export type LinkDownloadByArquivoQueryQuery = {
  __typename?: 'Query'
  linkDownloadByArquivo?: string | null
}

export type OpsQueryQueryVariables = Exact<{ [key: string]: never }>

export type OpsQueryQuery = {
  __typename?: 'Query'
  menuUsuarioLogado: { __typename?: 'MenuUsuario'; linkHelpTec?: string | null }
}

export type ArquivoQueryQueryVariables = Exact<{
  idArquivo: Scalars['ID']['input']
}>

export type ArquivoQueryQuery = {
  __typename?: 'Query'
  arquivo?: {
    __typename?: 'Arquivo'
    id: string
    nome: string
    tamanho?: any | null
  } | null
}

export type GetDadosComplementaresQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type GetDadosComplementaresQueryQuery = {
  __typename?: 'Query'
  usuarioLogado?: {
    __typename?: 'Usuario'
    dadosComplementares: Array<{
      __typename?: 'DadoComplementar'
      id: string
      descricao: string
      ordem: number
      urlBase: string
      tipo: string
      funcionalidades: Array<{
        __typename?: 'Funcionalidade'
        produto: { __typename?: 'Produto'; id: string; nome: string }
      } | null>
    } | null>
  } | null
}

export type DepartamentoFragmentFragment = {
  __typename?: 'Departamento'
  id: string
  nome: string
  sigla?: string | null
  assinatura?: string | null
}

export type DepartamentosCargosUsuariosQueryVariables = Exact<{
  [key: string]: never
}>

export type DepartamentosCargosUsuariosQuery = {
  __typename?: 'Query'
  departamentosCargosUsuarios?: Array<{
    __typename?: 'Departamento'
    id: string
    nome: string
    sigla?: string | null
    assinatura?: string | null
  } | null> | null
}

export type DepartamentosComunicadosQueryVariables = Exact<{
  [key: string]: never
}>

export type DepartamentosComunicadosQuery = {
  __typename?: 'Query'
  departamentosComunicados?: Array<{
    __typename?: 'Departamento'
    id: string
    nome: string
    sigla?: string | null
    assinatura?: string | null
  } | null> | null
}

export type GrupoFragmentFragment = {
  __typename?: 'Grupo'
  id: string
  nome: string
}

export type GruposAtivosQueryVariables = Exact<{ [key: string]: never }>

export type GruposAtivosQuery = {
  __typename?: 'Query'
  gruposAtivos?: Array<{
    __typename?: 'Grupo'
    id: string
    nome: string
  } | null> | null
}

export type MarcarNotificacoesComoVisualizadasMutationVariables = Exact<{
  [key: string]: never
}>

export type MarcarNotificacoesComoVisualizadasMutation = {
  __typename?: 'Mutation'
  marcarNotificacoesComoVisualizadas: boolean
}

export type NotificacoesMenuQueryVariables = Exact<{ [key: string]: never }>

export type NotificacoesMenuQuery = {
  __typename?: 'Query'
  notificacoesMenu?: Array<{
    __typename?: 'NotificacaoMenu'
    id: string
    titulo: string
    texto: string
    produto: string
    link?: string | null
    data: string
    recente: boolean
  } | null> | null
}

export type GetMenuCountNotificationsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetMenuCountNotificationsQuery = {
  __typename?: 'Query'
  countNotificacoesNaoLidas?: number | null
}

export type GetMenuUsuarioQueryVariables = Exact<{ [key: string]: never }>

export type GetMenuUsuarioQuery = {
  __typename?: 'Query'
  menuUsuarioLogado: {
    __typename?: 'MenuUsuario'
    title?: string | null
    theme?: string | null
    productName?: string | null
    currentProduct?: string | null
    linkHelpTec?: string | null
    linkPortal?: string | null
    linkAcademia?: string | null
    brandImageUrl?: string | null
    menus: string
    locales?: Array<{
      __typename: 'BaseEnum'
      id: string
      description: string
    } | null> | null
  }
}

export type SalvarUsuarioLogadoMutationMutationVariables = Exact<{
  id: Scalars['ID']['input']
  idioma: Idioma
}>

export type SalvarUsuarioLogadoMutationMutation = {
  __typename?: 'Mutation'
  mudarLinguaUsuario?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    idioma?: { __typename?: 'BaseEnum'; id: string } | null
  } | null
}

export type RedesSociaisQueryQueryVariables = Exact<{
  marca: Scalars['String']['input']
}>

export type RedesSociaisQueryQuery = {
  __typename?: 'Query'
  redesSociais?: Array<{
    __typename?: 'RedeSocial'
    id: string
    nome: string
    url: string
    icone: string
  } | null> | null
}

export type ComunicadoTemplatesQueryVariables = Exact<{ [key: string]: never }>

export type ComunicadoTemplatesQuery = {
  __typename?: 'Query'
  comunicadoTemplates: Array<{
    __typename?: 'TemplateOption'
    templateName: string
    description: string
  }>
}

export type GetUsuarioLogadoRolesQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUsuarioLogadoRolesQueryQuery = {
  __typename?: 'Query'
  usuarioLogado?: {
    __typename?: 'Usuario'
    id: string
    tipo?: { __typename?: 'BaseEnum'; id: string } | null
    funcionalidades?: Array<{
      __typename?: 'Funcionalidade'
      id: string
      chave: string
    } | null> | null
  } | null
}

export type GetUsuarioLogadoQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUsuarioLogadoQueryQuery = {
  __typename?: 'Query'
  usuarioLogado?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    avatarLink?: string | null
    marcas?: Array<{
      __typename?: 'Marca'
      id: string
      description: string
      facebookId?: string | null
    } | null> | null
    tipo?: { __typename?: 'BaseEnum'; id: string } | null
    idioma?: { __typename?: 'BaseEnum'; id: string } | null
    funcionalidades?: Array<{
      __typename?: 'Funcionalidade'
      id: string
      chave: string
    } | null> | null
    gruposUsuarios: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }>
  } | null
}

export type UsuariosByGruposUsuariosPagedQueryQueryVariables = Exact<{
  filterInput?: InputMaybe<UsuariosByGruposUsuariosFilterInput>
}>

export type UsuariosByGruposUsuariosPagedQueryQuery = {
  __typename?: 'Query'
  usuariosByGruposUsuariosPaged?: {
    __typename?: 'UsuarioPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null> | null
  } | null
}

export type OnboardingByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type OnboardingByIdQuery = {
  __typename?: 'Query'
  currentUserOnboardingIsSeen?: boolean | null
}

export type SetOnboardingIdMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type SetOnboardingIdMutation = {
  __typename?: 'Mutation'
  setCurrentUserOnboardingSeen?: boolean | null
}

export type I18nLabelsQueryVariables = Exact<{ [key: string]: never }>

export type I18nLabelsQuery = {
  __typename?: 'Query'
  i18nLabels: Array<{ __typename?: 'I18nLabel'; key: string; value: string }>
}

export type AnuncioFragmentFragment = {
  __typename?: 'Anuncio'
  id: string
  titulo: string
  link?: string | null
  linkTarget?: string | null
  inicioDate?: any | null
  fimDate?: any | null
  active: boolean
  createdDateTime: any
  emExibicao: boolean
  arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
  grupos?: Array<{
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
  }> | null
}

export type AnuncioPageQueryVariables = Exact<{
  filterInput: AnuncioFilterInput
}>

export type AnuncioPageQuery = {
  __typename?: 'Query'
  anunciosPaged?: {
    __typename?: 'AnuncioPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'Anuncio'
      id: string
      titulo: string
      link?: string | null
      linkTarget?: string | null
      inicioDate?: any | null
      fimDate?: any | null
      active: boolean
      createdDateTime: any
      emExibicao: boolean
      arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      }> | null
    } | null> | null
  } | null
}

export type AtivarAnuncioMutationVariables = Exact<{
  idAnuncio: Scalars['ID']['input']
}>

export type AtivarAnuncioMutation = {
  __typename?: 'Mutation'
  ativarAnuncio?: {
    __typename?: 'Anuncio'
    id: string
    titulo: string
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type InativarAnuncioMutationVariables = Exact<{
  idAnuncio: Scalars['ID']['input']
}>

export type InativarAnuncioMutation = {
  __typename?: 'Mutation'
  inativarAnuncio?: {
    __typename?: 'Anuncio'
    id: string
    titulo: string
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type AnuncioQueryQueryVariables = Exact<{
  idAnuncio: Scalars['ID']['input']
}>

export type AnuncioQueryQuery = {
  __typename?: 'Query'
  anuncio?: {
    __typename?: 'Anuncio'
    id: string
    titulo: string
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type SalvarAnuncioMutationVariables = Exact<{
  anuncioInput: AnuncioInput
}>

export type SalvarAnuncioMutation = {
  __typename?: 'Mutation'
  salvarAnuncio?: {
    __typename?: 'Anuncio'
    id: string
    titulo: string
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type RemoverAnuncioMutationVariables = Exact<{
  idAnuncio: Scalars['ID']['input']
}>

export type RemoverAnuncioMutation = {
  __typename?: 'Mutation'
  removerAnuncio?: string | null
}

export type AtivacaoEspecialUsuarioMutationVariables = Exact<{
  ativacaoEspecialUsuario: AtivacaoEspecialUsuarioInput
}>

export type AtivacaoEspecialUsuarioMutation = {
  __typename?: 'Mutation'
  salvarAtivacaoEspecialUsuario?: boolean | null
}

export type RemoverEspecialUsuarioMutationVariables = Exact<{
  idUsuario: Scalars['ID']['input']
}>

export type RemoverEspecialUsuarioMutation = {
  __typename?: 'Mutation'
  removerAtivacaoEspecialUsuario?: boolean | null
}

export type AtivacaoEspecialUsuarioByUsuarioIdQueryVariables = Exact<{
  usuarioId: Scalars['ID']['input']
}>

export type AtivacaoEspecialUsuarioByUsuarioIdQuery = {
  __typename?: 'Query'
  ativacaoEspecialUsuarioByUsuarioId?: {
    __typename?: 'AtivacaoEspecialUsuario'
    data: any
    justificativa: string
    solicitante: { __typename?: 'Usuario'; nome?: string | null }
  } | null
}

export type GetAuditoriaQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
  tipo: Scalars['String']['input']
}>

export type GetAuditoriaQueryQuery = {
  __typename?: 'Query'
  auditoria?: Array<{
    __typename?: 'RevisionDiff'
    dataHoraFormatada: string
    usuario: {
      __typename?: 'Usuario'
      nome?: string | null
      email?: string | null
    }
    diffs?: Array<{
      __typename?: 'RevisionDiffItem'
      propertyKey: string
      propertyLabel: string
      typeAsString: string
      oldValue?: string | null
      newValue?: string | null
    }> | null
  } | null> | null
}

export type SalvarAusenciaTemporariaMutationVariables = Exact<{
  ausenciaInput?: InputMaybe<AusenciaTemporariaInput>
}>

export type SalvarAusenciaTemporariaMutation = {
  __typename?: 'Mutation'
  salvarAusenciaTemporaria?: {
    __typename?: 'AusenciaTemporaria'
    id?: string | null
    dataInicio?: any | null
    dataRetorno?: any | null
    motivo?: {
      __typename?: 'MotivoAusenciaTemporaria'
      id?: string | null
      motivo?: string | null
    } | null
    documentoComprobatorio?: {
      __typename?: 'Arquivo'
      id: string
      nome: string
    } | null
    ausenciaTemporariaStatus?: {
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null
  } | null
}

export type RemoveAusenciaTemporariaMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type RemoveAusenciaTemporariaMutation = {
  __typename?: 'Mutation'
  removeAusenciaTemporaria?: boolean | null
}

export type AusenciaFragmentFragment = {
  __typename?: 'AusenciaTemporaria'
  id?: string | null
  dataInicio?: any | null
  dataRetorno?: any | null
  motivo?: {
    __typename?: 'MotivoAusenciaTemporaria'
    id?: string | null
    motivo?: string | null
  } | null
  documentoComprobatorio?: {
    __typename?: 'Arquivo'
    id: string
    nome: string
  } | null
  ausenciaTemporariaStatus?: {
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null
}

export type AusenciaTemporariaQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AusenciaTemporariaQueryQuery = {
  __typename?: 'Query'
  ausenciaTemporaria?: {
    __typename?: 'AusenciaTemporaria'
    id?: string | null
    dataInicio?: any | null
    dataRetorno?: any | null
    motivo?: {
      __typename?: 'MotivoAusenciaTemporaria'
      id?: string | null
      motivo?: string | null
    } | null
    documentoComprobatorio?: {
      __typename?: 'Arquivo'
      id: string
      nome: string
    } | null
    ausenciaTemporariaStatus?: {
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null
  } | null
}

export type AusenciasTemporariasQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AusenciasTemporariasQueryQuery = {
  __typename?: 'Query'
  ausenciasTemporarias?: Array<{
    __typename?: 'AusenciaTemporaria'
    id?: string | null
    dataInicio?: any | null
    dataRetorno?: any | null
    motivo?: {
      __typename?: 'MotivoAusenciaTemporaria'
      id?: string | null
      motivo?: string | null
    } | null
    documentoComprobatorio?: {
      __typename?: 'Arquivo'
      id: string
      nome: string
    } | null
    ausenciaTemporariaStatus?: {
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null
  } | null> | null
}

export type MotivosAusenciaTemporariaQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type MotivosAusenciaTemporariaQueryQuery = {
  __typename?: 'Query'
  motivosAusenciaTemporaria?: Array<{
    __typename?: 'MotivoAusenciaTemporaria'
    id?: string | null
    motivo?: string | null
  } | null> | null
}

export type BuscaBibliotecaPageQueryVariables = Exact<{
  filterInput: ItemBibliotecaFilterInput
}>

export type BuscaBibliotecaPageQuery = {
  __typename?: 'Query'
  buscaBibliotecaPaged?: {
    __typename?: 'ItemBibliotecaPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'ItemBiblioteca'
      id: string
      nome: string
      isPasta?: boolean | null
      isPublico?: boolean | null
      ultimaModificacao?: any | null
      dataCriacao?: any | null
      arquivoLink?: string | null
      arquivoMiniaturaLink?: string | null
      arquivoImagem?: boolean | null
      pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
      proprietario?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null
      permissoesAcessoUsuarioLogado: Array<{
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null>
      permissoes?: Array<{
        __typename?: 'GruposUsuarioPermissoes'
        id: string
        grupoUsuarios: {
          __typename?: 'GrupoUsuarios'
          id: string
          nome: string
          favorito?: boolean | null
        }
        permissaoAcessoPasta: { __typename?: 'BaseEnum'; id: string }
      } | null> | null
    } | null> | null
  } | null
}

export type ConcederAcessoMutationMutationVariables = Exact<{
  novasPermissoes: ConcederAcessoInput
}>

export type ConcederAcessoMutationMutation = {
  __typename?: 'Mutation'
  concederAcesso?: {
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
    isPasta?: boolean | null
    isPublico?: boolean | null
    ultimaModificacao?: any | null
    dataCriacao?: any | null
    arquivoLink?: string | null
    arquivoMiniaturaLink?: string | null
    arquivoImagem?: boolean | null
    pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
    proprietario?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null
    permissoesAcessoUsuarioLogado: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null>
    permissoes?: Array<{
      __typename?: 'GruposUsuarioPermissoes'
      id: string
      grupoUsuarios: {
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
        favorito?: boolean | null
      }
      permissaoAcessoPasta: { __typename?: 'BaseEnum'; id: string }
    } | null> | null
  } | null
}

export type CriarNovaPastaMutationMutationVariables = Exact<{
  novaPasta: NovaPastaInput
}>

export type CriarNovaPastaMutationMutation = {
  __typename?: 'Mutation'
  criarNovaPasta?: {
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
    pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
  } | null
}

export type DownloadBatchQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type DownloadBatchQuery = {
  __typename?: 'Query'
  downloadBatch: Array<{
    __typename?: 'ItemDownload'
    path: string
    link: string
  }>
}

export type ExcluirItemMutationMutationVariables = Exact<{
  idItem: Scalars['ID']['input']
}>

export type ExcluirItemMutationMutation = {
  __typename?: 'Mutation'
  excluirItemBiblioteca?: {
    __typename?: 'ItemBiblioteca'
    id: string
    pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
  } | null
}

export type GenerateDownloadLinkMutationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GenerateDownloadLinkMutationMutation = {
  __typename?: 'Mutation'
  gerarLinkDownloadByItemBiblioteca?: string | null
}

export type ItemPastaFragmentFragment = {
  __typename?: 'ItemBiblioteca'
  id: string
  nome: string
  isPasta?: boolean | null
  isPublico?: boolean | null
  ultimaModificacao?: any | null
  dataCriacao?: any | null
  arquivoLink?: string | null
  arquivoMiniaturaLink?: string | null
  arquivoImagem?: boolean | null
  pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
  proprietario?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
  } | null
  permissoesAcessoUsuarioLogado: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null>
  permissoes?: Array<{
    __typename?: 'GruposUsuarioPermissoes'
    id: string
    grupoUsuarios: {
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
      favorito?: boolean | null
    }
    permissaoAcessoPasta: { __typename?: 'BaseEnum'; id: string }
  } | null> | null
}

export type GetItemsPorPastaQueryVariables = Exact<{
  idPasta?: InputMaybe<Scalars['ID']['input']>
}>

export type GetItemsPorPastaQuery = {
  __typename?: 'Query'
  itemsPorPasta?: {
    __typename?: 'ItemsPorPasta'
    totalItems?: number | null
    totalFiles?: number | null
    totalFolders?: number | null
    content?: Array<{
      __typename?: 'ItemBiblioteca'
      id: string
      nome: string
      isPasta?: boolean | null
      isPublico?: boolean | null
      ultimaModificacao?: any | null
      dataCriacao?: any | null
      arquivoLink?: string | null
      arquivoMiniaturaLink?: string | null
      arquivoImagem?: boolean | null
      pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
      proprietario?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null
      permissoesAcessoUsuarioLogado: Array<{
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null>
      permissoes?: Array<{
        __typename?: 'GruposUsuarioPermissoes'
        id: string
        grupoUsuarios: {
          __typename?: 'GrupoUsuarios'
          id: string
          nome: string
          favorito?: boolean | null
        }
        permissaoAcessoPasta: { __typename?: 'BaseEnum'; id: string }
      } | null> | null
    } | null> | null
  } | null
}

export type MoverItemMutationMutationVariables = Exact<{
  idItemBiblioteca: Scalars['ID']['input']
  novaLocalizacao: Scalars['ID']['input']
}>

export type MoverItemMutationMutation = {
  __typename?: 'Mutation'
  moverItemBiblioteca?: {
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
    pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
  } | null
}

export type GetPastaQueryVariables = Exact<{
  idPasta?: InputMaybe<Scalars['ID']['input']>
}>

export type GetPastaQuery = {
  __typename?: 'Query'
  pasta?: {
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
    isPublico?: boolean | null
    breadcrumb?: Array<{
      __typename?: 'ItemBiblioteca'
      id: string
      nome: string
    } | null> | null
    permissoesAcessoUsuarioLogado: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null>
  } | null
}

export type GetPastaPermissaoEscritaQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type GetPastaPermissaoEscritaQueryQuery = {
  __typename?: 'Query'
  pastasComPermissaoEscrita?: Array<{
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
  } | null> | null
}

export type RenomearItemMutationMutationVariables = Exact<{
  idItemBiblioteca: Scalars['ID']['input']
  novoNome: Scalars['String']['input']
}>

export type RenomearItemMutationMutation = {
  __typename?: 'Mutation'
  renomearItemBiblioteca?: {
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
    pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
  } | null
}

export type UltimosModificadosQueryGqlQueryVariables = Exact<{
  [key: string]: never
}>

export type UltimosModificadosQueryGqlQuery = {
  __typename?: 'Query'
  ultimosModificados?: Array<{
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
    isPasta?: boolean | null
    isPublico?: boolean | null
    ultimaModificacao?: any | null
    dataCriacao?: any | null
    arquivoLink?: string | null
    arquivoMiniaturaLink?: string | null
    arquivoImagem?: boolean | null
    pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
    proprietario?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null
    permissoesAcessoUsuarioLogado: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null>
    permissoes?: Array<{
      __typename?: 'GruposUsuarioPermissoes'
      id: string
      grupoUsuarios: {
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
        favorito?: boolean | null
      }
      permissaoAcessoPasta: { __typename?: 'BaseEnum'; id: string }
    } | null> | null
  } | null> | null
}

export type UltimosModificadosQueryGqlExtendedQueryVariables = Exact<{
  [key: string]: never
}>

export type UltimosModificadosQueryGqlExtendedQuery = {
  __typename?: 'Query'
  ultimosModificados?: Array<{
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
    isPasta?: boolean | null
    ultimaModificacao?: any | null
    dataCriacao?: any | null
    pastaPai?: {
      __typename?: 'ItemBiblioteca'
      id: string
      nome: string
    } | null
    proprietario?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    permissoesAcessoUsuarioLogado: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null>
    permissoes?: Array<{
      __typename?: 'GruposUsuarioPermissoes'
      id: string
      grupoUsuarios: { __typename?: 'GrupoUsuarios'; id: string; nome: string }
      permissaoAcessoPasta: { __typename?: 'BaseEnum'; id: string }
    } | null> | null
  } | null> | null
}

export type UploadArquivosMutationMutationVariables = Exact<{
  arquivos: Array<ItemBibliotecaInput> | ItemBibliotecaInput
}>

export type UploadArquivosMutationMutation = {
  __typename?: 'Mutation'
  uploadArquivos?: Array<{
    __typename?: 'ItemBiblioteca'
    id: string
    nome: string
    pastaPai?: { __typename?: 'ItemBiblioteca'; id: string } | null
  } | null> | null
}

export type ComunicadoEnvioFragmentFragment = {
  __typename?: 'ComunicadoEnvio'
  id: string
  lido: boolean
  arquivado: boolean
  favorito: boolean
  active: boolean
  comunicado?: {
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null
}

export type MarcarComunicadoEnvioComoLidoMutationVariables = Exact<{
  idComunicadoEnvio: Scalars['ID']['input']
}>

export type MarcarComunicadoEnvioComoLidoMutation = {
  __typename?: 'Mutation'
  marcarComunicadoEnvioComoLido?: {
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null
}

export type ComunicadoEnviosQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ComunicadoEnviosQueryQuery = {
  __typename?: 'Query'
  comunicadoEnvios?: Array<{
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null> | null
}

export type ComunicadoFragmentFragment = {
  __typename?: 'Comunicado'
  id: string
  titulo: string
  mensagem: string
  createdDateTime: any
  envioDateTime?: any | null
  motivoRejeicao?: string | null
  dataHoraAgendamento?: any | null
  rascunho: boolean
  enviado: boolean
  emAprovacao: boolean
  rejeitado: boolean
  active: boolean
  idParent?: string | null
  templateName?: string | null
  status: { __typename?: 'BaseEnum'; id: string; description: string }
  usuarioCriador: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
  }
  usuarioAprovador?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
  } | null
  grupos?: Array<{
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
  } | null> | null
  usuariosRemovidos?: Array<{
    __typename?: 'Usuario'
    id: string
    nome?: string | null
  } | null> | null
  etiquetas?: Array<{
    __typename?: 'Etiqueta'
    id: string
    nome: string
  } | null> | null
  arquivos?: Array<{
    __typename?: 'Arquivo'
    id: string
    nome: string
    tamanho?: any | null
  } | null> | null
  emailsAvulsos?: Array<{
    __typename?: 'EmailAvulso'
    email?: string | null
    status?: {
      __typename?: 'StatusEmailEnum'
      name?: string | null
      descricao?: string | null
    } | null
  } | null> | null
  departamento?: {
    __typename?: 'Departamento'
    id: string
    sigla?: string | null
    nome: string
    assinatura?: string | null
  } | null
}

export type ComunicadoQueryQueryVariables = Exact<{
  idComunicado: Scalars['ID']['input']
  isErrataContext?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ComunicadoQueryQuery = {
  __typename?: 'Query'
  comunicado?: {
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null
}

export type ComunicadosQueryQueryVariables = Exact<{ [key: string]: never }>

export type ComunicadosQueryQuery = {
  __typename?: 'Query'
  comunicados?: Array<{
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null> | null
}

export type ComunicadoDashboardQueryQueryVariables = Exact<{
  idComunicado: Scalars['ID']['input']
}>

export type ComunicadoDashboardQueryQuery = {
  __typename?: 'Query'
  comunicadoDashboard?: {
    __typename?: 'ComunicadoDashboard'
    id: string
    enviados?: Array<{
      __typename?: 'ComunicadoEnvio'
      id: string
      createdDateTime?: any | null
      usuario: {
        __typename?: 'Usuario'
        nome?: string | null
        email?: string | null
      }
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    lidos?: Array<{
      __typename?: 'ComunicadoEnvio'
      id: string
      leituraDateTime?: any | null
      usuario: {
        __typename?: 'Usuario'
        nome?: string | null
        email?: string | null
      }
    } | null> | null
    arquivados?: Array<{
      __typename?: 'ComunicadoEnvio'
      id: string
      arquivamentoDateTime?: any | null
      usuario: {
        __typename?: 'Usuario'
        nome?: string | null
        email?: string | null
      }
    } | null> | null
    downloads?: Array<{
      __typename?: 'ArquivoDownload'
      id: string
      createdDateTime: any
      usuario: { __typename?: 'Usuario'; nome?: string | null }
      arquivo: { __typename?: 'Arquivo'; nome: string }
    } | null> | null
    comunicado: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    }
  } | null
}

export type LinkDownloadByArquivoMutationMutationVariables = Exact<{
  idArquivo: Scalars['ID']['input']
  registrarDownload: Scalars['Boolean']['input']
}>

export type LinkDownloadByArquivoMutationMutation = {
  __typename?: 'Mutation'
  linkDownloadByArquivo?: string | null
}

export type ComunicadoUsuariosAprovadoresQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ComunicadoUsuariosAprovadoresQueryQuery = {
  __typename?: 'Query'
  comunicadoUsuariosAprovadores?: Array<{
    __typename?: 'Usuario'
    id: string
    nome?: string | null
  } | null> | null
}

export type ComunicadosParaAprovacaoQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ComunicadosParaAprovacaoQueryQuery = {
  __typename?: 'Query'
  comunicadosParaAprovacao?: Array<{
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null> | null
}

export type EnviarComunicadoAprovacaoMutationVariables = Exact<{
  idComunicado: Scalars['ID']['input']
  idUsuarioAprovador: Scalars['ID']['input']
}>

export type EnviarComunicadoAprovacaoMutation = {
  __typename?: 'Mutation'
  enviarComunicadoParaAprovacao?: {
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null
}

export type EnviarComunicadoMutationVariables = Exact<{
  idComunicado: Scalars['ID']['input']
}>

export type EnviarComunicadoMutation = {
  __typename?: 'Mutation'
  enviarComunicado?: {
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null
}

export type ExistemUsuariosEmGruposQueryVariables = Exact<{
  grupos: Array<GrupoUsuariosInput> | GrupoUsuariosInput
}>

export type ExistemUsuariosEmGruposQuery = {
  __typename?: 'Query'
  existemUsuariosEmGrupos?: boolean | null
}

export type ComunicadoPreviewQueryVariables = Exact<{
  conteudo: Scalars['String']['input']
  titulo: Scalars['String']['input']
  rodape?: InputMaybe<Scalars['String']['input']>
  templateName?: InputMaybe<Scalars['String']['input']>
}>

export type ComunicadoPreviewQuery = {
  __typename?: 'Query'
  comunicadoPreview?: string | null
}

export type RejeitarComunicadoMutationVariables = Exact<{
  idComunicado: Scalars['ID']['input']
  motivoRejeicao: Scalars['String']['input']
}>

export type RejeitarComunicadoMutation = {
  __typename?: 'Mutation'
  rejeitarComunicado?: {
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null
}

export type SalvarComunicadoMutationVariables = Exact<{
  comunicadoInput: ComunicadoInput
}>

export type SalvarComunicadoMutation = {
  __typename?: 'Mutation'
  salvarComunicado?: {
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null
}

export type ComunicadoSequenciamentoQueryVariables = Exact<{
  idDepartamento: Scalars['ID']['input']
}>

export type ComunicadoSequenciamentoQuery = {
  __typename?: 'Query'
  comunicadoSequenciamento?: string | null
}

export type EtiquetasByNomeStartingWithQueryQueryVariables = Exact<{
  nome: Scalars['String']['input']
}>

export type EtiquetasByNomeStartingWithQueryQuery = {
  __typename?: 'Query'
  etiquetasByNomeStartingWith?: Array<{
    __typename?: 'Etiqueta'
    id: string
    nome: string
  } | null> | null
}

export type ArquivarComunicadoEnvioMutationVariables = Exact<{
  idComunicadoEnvio: Scalars['ID']['input']
}>

export type ArquivarComunicadoEnvioMutation = {
  __typename?: 'Mutation'
  arquivarComunicadoEnvio?: {
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null
}

export type ComunicadoEnviosArquivadosQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ComunicadoEnviosArquivadosQueryQuery = {
  __typename?: 'Query'
  comunicadoEnviosArquivados?: Array<{
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null> | null
}

export type ComunicadoEnviosPagedQueryVariables = Exact<{
  filterInput: ComunicadoEnvioFilterInput
}>

export type ComunicadoEnviosPagedQuery = {
  __typename?: 'Query'
  comunicadoEnviosPaged?: {
    __typename?: 'ComunicadoEnvioPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'ComunicadoEnvio'
      id: string
      lido: boolean
      arquivado: boolean
      favorito: boolean
      active: boolean
      comunicado?: {
        __typename?: 'Comunicado'
        id: string
        titulo: string
        mensagem: string
        createdDateTime: any
        envioDateTime?: any | null
        motivoRejeicao?: string | null
        dataHoraAgendamento?: any | null
        rascunho: boolean
        enviado: boolean
        emAprovacao: boolean
        rejeitado: boolean
        active: boolean
        idParent?: string | null
        templateName?: string | null
        status: { __typename?: 'BaseEnum'; id: string; description: string }
        usuarioCriador: {
          __typename?: 'Usuario'
          id: string
          nome?: string | null
          email?: string | null
        }
        usuarioAprovador?: {
          __typename?: 'Usuario'
          id: string
          nome?: string | null
          email?: string | null
        } | null
        grupos?: Array<{
          __typename?: 'GrupoUsuarios'
          id: string
          nome: string
        } | null> | null
        usuariosRemovidos?: Array<{
          __typename?: 'Usuario'
          id: string
          nome?: string | null
        } | null> | null
        etiquetas?: Array<{
          __typename?: 'Etiqueta'
          id: string
          nome: string
        } | null> | null
        arquivos?: Array<{
          __typename?: 'Arquivo'
          id: string
          nome: string
          tamanho?: any | null
        } | null> | null
        emailsAvulsos?: Array<{
          __typename?: 'EmailAvulso'
          email?: string | null
          status?: {
            __typename?: 'StatusEmailEnum'
            name?: string | null
            descricao?: string | null
          } | null
        } | null> | null
        departamento?: {
          __typename?: 'Departamento'
          id: string
          sigla?: string | null
          nome: string
          assinatura?: string | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type ComunicadosPagedQueryVariables = Exact<{
  filterInput: ComunicadoFilterInput
}>

export type ComunicadosPagedQuery = {
  __typename?: 'Query'
  comunicadosPaged?: {
    __typename?: 'ComunicadoPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null> | null
  } | null
}

export type MarcarComunicadoEnvioComoFavoritoMutationVariables = Exact<{
  idComunicadoEnvio: Scalars['ID']['input']
}>

export type MarcarComunicadoEnvioComoFavoritoMutation = {
  __typename?: 'Mutation'
  marcarComunicadoEnvioComoFavorito?: {
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null
}

export type MarcarComunicadoEnvioComoNaoFavoritoMutationVariables = Exact<{
  idComunicadoEnvio: Scalars['ID']['input']
}>

export type MarcarComunicadoEnvioComoNaoFavoritoMutation = {
  __typename?: 'Mutation'
  marcarComunicadoEnvioComoNaoFavorito?: {
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null
}

export type MarcarComunicadoEnvioComoNaoLidoMutationVariables = Exact<{
  idComunicadoEnvio: Scalars['ID']['input']
}>

export type MarcarComunicadoEnvioComoNaoLidoMutation = {
  __typename?: 'Mutation'
  marcarComunicadoEnvioComoNaoLido?: {
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null
}

export type RemoverComunicadoMutationVariables = Exact<{
  idComunicado: Scalars['ID']['input']
}>

export type RemoverComunicadoMutation = {
  __typename?: 'Mutation'
  removerComunicado?: {
    __typename?: 'Comunicado'
    id: string
    titulo: string
    mensagem: string
    createdDateTime: any
    envioDateTime?: any | null
    motivoRejeicao?: string | null
    dataHoraAgendamento?: any | null
    rascunho: boolean
    enviado: boolean
    emAprovacao: boolean
    rejeitado: boolean
    active: boolean
    idParent?: string | null
    templateName?: string | null
    status: { __typename?: 'BaseEnum'; id: string; description: string }
    usuarioCriador: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
    usuarioAprovador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    } | null> | null
    usuariosRemovidos?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
    } | null> | null
    etiquetas?: Array<{
      __typename?: 'Etiqueta'
      id: string
      nome: string
    } | null> | null
    arquivos?: Array<{
      __typename?: 'Arquivo'
      id: string
      nome: string
      tamanho?: any | null
    } | null> | null
    emailsAvulsos?: Array<{
      __typename?: 'EmailAvulso'
      email?: string | null
      status?: {
        __typename?: 'StatusEmailEnum'
        name?: string | null
        descricao?: string | null
      } | null
    } | null> | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      sigla?: string | null
      nome: string
      assinatura?: string | null
    } | null
  } | null
}

export type RestaurarComunicadoEnvioMutationVariables = Exact<{
  idComunicadoEnvio: Scalars['ID']['input']
}>

export type RestaurarComunicadoEnvioMutation = {
  __typename?: 'Mutation'
  restaurarComunicadoEnvio?: {
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null
}

export type ComunicadoEnviosRecentesQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ComunicadoEnviosRecentesQueryQuery = {
  __typename?: 'Query'
  comunicadoEnviosRecentes?: Array<{
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null> | null
}

export type ComunicadoEnvioQueryQueryVariables = Exact<{
  idComunicado: Scalars['ID']['input']
}>

export type ComunicadoEnvioQueryQuery = {
  __typename?: 'Query'
  comunicadoEnvio?: {
    __typename?: 'ComunicadoEnvio'
    id: string
    lido: boolean
    arquivado: boolean
    favorito: boolean
    active: boolean
    comunicado?: {
      __typename?: 'Comunicado'
      id: string
      titulo: string
      mensagem: string
      createdDateTime: any
      envioDateTime?: any | null
      motivoRejeicao?: string | null
      dataHoraAgendamento?: any | null
      rascunho: boolean
      enviado: boolean
      emAprovacao: boolean
      rejeitado: boolean
      active: boolean
      idParent?: string | null
      templateName?: string | null
      status: { __typename?: 'BaseEnum'; id: string; description: string }
      usuarioCriador: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
      usuarioAprovador?: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      } | null
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      } | null> | null
      usuariosRemovidos?: Array<{
        __typename?: 'Usuario'
        id: string
        nome?: string | null
      } | null> | null
      etiquetas?: Array<{
        __typename?: 'Etiqueta'
        id: string
        nome: string
      } | null> | null
      arquivos?: Array<{
        __typename?: 'Arquivo'
        id: string
        nome: string
        tamanho?: any | null
      } | null> | null
      emailsAvulsos?: Array<{
        __typename?: 'EmailAvulso'
        email?: string | null
        status?: {
          __typename?: 'StatusEmailEnum'
          name?: string | null
          descricao?: string | null
        } | null
      } | null> | null
      departamento?: {
        __typename?: 'Departamento'
        id: string
        sigla?: string | null
        nome: string
        assinatura?: string | null
      } | null
    } | null
  } | null
}

export type DealerDominioQueryQueryVariables = Exact<{ [key: string]: never }>

export type DealerDominioQueryQuery = {
  __typename?: 'Query'
  gruposAtivos?: Array<{
    __typename?: 'Grupo'
    id: string
    nome: string
    marcas?: Array<{
      __typename?: 'Marca'
      id: string
      description: string
    } | null> | null
  } | null> | null
  marcas?: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null> | null
  produtos?: Array<{
    __typename?: 'Produto'
    id: string
    chave: string
    nome: string
  } | null> | null
  estados?: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null> | null
  produtosSemPortal?: Array<{
    __typename?: 'Produto'
    id: string
    nome: string
  } | null> | null
}

export type DealerFragmentFragment = {
  __typename?: 'Dealer'
  id: string
  nome: string
  razaoSocial: string
  cnpj: string
  cnpjsAdicionais?: Array<string> | null
  codigoPrincipal: string
  active: boolean
  codigos?: Array<string | null> | null
  telefones?: Array<string | null> | null
  email?: string | null
  inicioOperacao?: any | null
  fimOperacao?: any | null
  grupo: {
    __typename?: 'Grupo'
    id: string
    nome: string
    marcas?: Array<{
      __typename?: 'Marca'
      id: string
      description: string
    } | null> | null
  }
  endereco: {
    __typename?: 'Endereco'
    id: string
    logradouro?: string | null
    numero?: number | null
    complemento?: string | null
    bairro?: string | null
    cidade?: string | null
    cep?: string | null
    estado?: { __typename?: 'BaseEnum'; id: string; description: string } | null
  }
  marcas?: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null> | null
  produtos?: Array<{
    __typename?: 'Produto'
    id: string
    nome: string
  } | null> | null
}

export type BuscaEnderecoQueryVariables = Exact<{
  cep: Scalars['String']['input']
}>

export type BuscaEnderecoQuery = {
  __typename?: 'Query'
  endereco?: {
    __typename?: 'EnderecoCEP'
    type?: string | null
    place?: string | null
    neighborhood?: string | null
    city?: string | null
    uf?: string | null
    postalCode?: string | null
  } | null
}

export type DealerQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DealerQueryQuery = {
  __typename?: 'Query'
  dealer?: {
    __typename?: 'Dealer'
    id: string
    nome: string
    razaoSocial: string
    cnpj: string
    cnpjsAdicionais?: Array<string> | null
    codigoPrincipal: string
    active: boolean
    codigos?: Array<string | null> | null
    telefones?: Array<string | null> | null
    email?: string | null
    inicioOperacao?: any | null
    fimOperacao?: any | null
    grupo: {
      __typename?: 'Grupo'
      id: string
      nome: string
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
    }
    endereco: {
      __typename?: 'Endereco'
      id: string
      logradouro?: string | null
      numero?: number | null
      complemento?: string | null
      bairro?: string | null
      cidade?: string | null
      cep?: string | null
      estado?: {
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null
    }
    marcas?: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null> | null
    produtos?: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
    } | null> | null
  } | null
}

export type DealerByCnpjQueryQueryVariables = Exact<{
  cnpj: Scalars['String']['input']
}>

export type DealerByCnpjQueryQuery = {
  __typename?: 'Query'
  dealerByCNPJ?: {
    __typename?: 'Dealer'
    id: string
    nome: string
    razaoSocial: string
    cnpj: string
    cnpjsAdicionais?: Array<string> | null
    codigoPrincipal: string
    active: boolean
    codigos?: Array<string | null> | null
    telefones?: Array<string | null> | null
    email?: string | null
    inicioOperacao?: any | null
    fimOperacao?: any | null
    grupo: {
      __typename?: 'Grupo'
      id: string
      nome: string
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
    }
    endereco: {
      __typename?: 'Endereco'
      id: string
      logradouro?: string | null
      numero?: number | null
      complemento?: string | null
      bairro?: string | null
      cidade?: string | null
      cep?: string | null
      estado?: {
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null
    }
    marcas?: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null> | null
    produtos?: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
    } | null> | null
  } | null
}

export type DealerByCodigosQueryQueryVariables = Exact<{
  codigo: Scalars['String']['input']
}>

export type DealerByCodigosQueryQuery = {
  __typename?: 'Query'
  dealerByCodigo?: {
    __typename?: 'Dealer'
    id: string
    nome: string
    razaoSocial: string
    cnpj: string
    cnpjsAdicionais?: Array<string> | null
    codigoPrincipal: string
    active: boolean
    codigos?: Array<string | null> | null
    telefones?: Array<string | null> | null
    email?: string | null
    inicioOperacao?: any | null
    fimOperacao?: any | null
    grupo: {
      __typename?: 'Grupo'
      id: string
      nome: string
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
    }
    endereco: {
      __typename?: 'Endereco'
      id: string
      logradouro?: string | null
      numero?: number | null
      complemento?: string | null
      bairro?: string | null
      cidade?: string | null
      cep?: string | null
      estado?: {
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null
    }
    marcas?: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null> | null
    produtos?: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
    } | null> | null
  } | null
}

export type DealerPageQueryVariables = Exact<{
  filterInput: DealerFilterInput
}>

export type DealerPageQuery = {
  __typename?: 'Query'
  dealersPaged?: {
    __typename?: 'DealerPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'Dealer'
      id: string
      nome: string
      razaoSocial: string
      cnpj: string
      cnpjsAdicionais?: Array<string> | null
      codigoPrincipal: string
      active: boolean
      codigos?: Array<string | null> | null
      telefones?: Array<string | null> | null
      email?: string | null
      inicioOperacao?: any | null
      fimOperacao?: any | null
      grupo: {
        __typename?: 'Grupo'
        id: string
        nome: string
        marcas?: Array<{
          __typename?: 'Marca'
          id: string
          description: string
        } | null> | null
      }
      endereco: {
        __typename?: 'Endereco'
        id: string
        logradouro?: string | null
        numero?: number | null
        complemento?: string | null
        bairro?: string | null
        cidade?: string | null
        cep?: string | null
        estado?: {
          __typename?: 'BaseEnum'
          id: string
          description: string
        } | null
      }
      marcas?: Array<{
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null> | null
      produtos?: Array<{
        __typename?: 'Produto'
        id: string
        nome: string
      } | null> | null
    } | null> | null
  } | null
}

export type DivisoesQueryVariables = Exact<{ [key: string]: never }>

export type DivisoesQuery = {
  __typename?: 'Query'
  divisoes?: Array<{
    __typename?: 'Divisao'
    id: string
    nome: string
  } | null> | null
}

export type InfoDealerQueryQueryVariables = Exact<{
  dealerId: Scalars['ID']['input']
}>

export type InfoDealerQueryQuery = {
  __typename?: 'Query'
  infoDealer?: {
    __typename?: 'InfoDealer'
    id: string
    divisao?: { __typename?: 'Divisao'; id: string; nome: string } | null
    setor?: { __typename?: 'Setor'; id: string; nome: string } | null
  } | null
}

export type SalvarDealerMutationVariables = Exact<{
  dealer: DealerInput
  infos?: InputMaybe<InfoDealerInput>
}>

export type SalvarDealerMutation = {
  __typename?: 'Mutation'
  salvarDealer?: {
    __typename?: 'Dealer'
    id: string
    nome: string
    razaoSocial: string
    cnpj: string
    cnpjsAdicionais?: Array<string> | null
    codigoPrincipal: string
    active: boolean
    codigos?: Array<string | null> | null
    telefones?: Array<string | null> | null
    email?: string | null
    inicioOperacao?: any | null
    fimOperacao?: any | null
    grupo: {
      __typename?: 'Grupo'
      id: string
      nome: string
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
    }
    endereco: {
      __typename?: 'Endereco'
      id: string
      logradouro?: string | null
      numero?: number | null
      complemento?: string | null
      bairro?: string | null
      cidade?: string | null
      cep?: string | null
      estado?: {
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null
    }
    marcas?: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null> | null
    produtos?: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
    } | null> | null
  } | null
}

export type SetoresQueryVariables = Exact<{ [key: string]: never }>

export type SetoresQuery = {
  __typename?: 'Query'
  setores?: Array<{
    __typename?: 'Setor'
    id: string
    nome: string
    divisao?: { __typename?: 'Divisao'; id: string; nome: string } | null
  } | null> | null
}

export type AtivarDealerMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtivarDealerMutation = {
  __typename?: 'Mutation'
  ativarDealer?: {
    __typename?: 'Dealer'
    id: string
    nome: string
    razaoSocial: string
    cnpj: string
    cnpjsAdicionais?: Array<string> | null
    codigoPrincipal: string
    active: boolean
    codigos?: Array<string | null> | null
    telefones?: Array<string | null> | null
    email?: string | null
    inicioOperacao?: any | null
    fimOperacao?: any | null
    grupo: {
      __typename?: 'Grupo'
      id: string
      nome: string
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
    }
    endereco: {
      __typename?: 'Endereco'
      id: string
      logradouro?: string | null
      numero?: number | null
      complemento?: string | null
      bairro?: string | null
      cidade?: string | null
      cep?: string | null
      estado?: {
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null
    }
    marcas?: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null> | null
    produtos?: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
    } | null> | null
  } | null
}

export type DealersQueryQueryVariables = Exact<{ [key: string]: never }>

export type DealersQueryQuery = {
  __typename?: 'Query'
  dealers?: Array<{
    __typename?: 'Dealer'
    id: string
    nome: string
    razaoSocial: string
    cnpj: string
    cnpjsAdicionais?: Array<string> | null
    codigoPrincipal: string
    active: boolean
    codigos?: Array<string | null> | null
    telefones?: Array<string | null> | null
    email?: string | null
    inicioOperacao?: any | null
    fimOperacao?: any | null
    grupo: {
      __typename?: 'Grupo'
      id: string
      nome: string
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
    }
    endereco: {
      __typename?: 'Endereco'
      id: string
      logradouro?: string | null
      numero?: number | null
      complemento?: string | null
      bairro?: string | null
      cidade?: string | null
      cep?: string | null
      estado?: {
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null
    }
    marcas?: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null> | null
    produtos?: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
    } | null> | null
  } | null> | null
}

export type ExportarDealersMutationVariables = Exact<{
  filtro: DealerFilterInput
}>

export type ExportarDealersMutation = {
  __typename?: 'Mutation'
  exportarDealers?: boolean | null
}

export type InativarDealerMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InativarDealerMutation = {
  __typename?: 'Mutation'
  inativarDealer?: {
    __typename?: 'Dealer'
    id: string
    nome: string
    razaoSocial: string
    cnpj: string
    cnpjsAdicionais?: Array<string> | null
    codigoPrincipal: string
    active: boolean
    codigos?: Array<string | null> | null
    telefones?: Array<string | null> | null
    email?: string | null
    inicioOperacao?: any | null
    fimOperacao?: any | null
    grupo: {
      __typename?: 'Grupo'
      id: string
      nome: string
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
    }
    endereco: {
      __typename?: 'Endereco'
      id: string
      logradouro?: string | null
      numero?: number | null
      complemento?: string | null
      bairro?: string | null
      cidade?: string | null
      cep?: string | null
      estado?: {
        __typename?: 'BaseEnum'
        id: string
        description: string
      } | null
    }
    marcas?: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null> | null
    produtos?: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
    } | null> | null
  } | null
}

export type GrupoDealerFragmentFragment = {
  __typename?: 'Grupo'
  id: string
  nome: string
  active: boolean
  dealers?: Array<{
    __typename?: 'Dealer'
    id: string
    nome: string
    produtos?: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
    } | null> | null
  } | null> | null
  marcas?: Array<{
    __typename?: 'Marca'
    id: string
    description: string
  } | null> | null
}

export type GruposPagedQueryVariables = Exact<{
  filterInput: GrupoFilterInput
}>

export type GruposPagedQuery = {
  __typename?: 'Query'
  gruposPaged?: {
    __typename?: 'GrupoPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'Grupo'
      id: string
      nome: string
      active: boolean
      dealers?: Array<{
        __typename?: 'Dealer'
        id: string
        nome: string
        produtos?: Array<{
          __typename?: 'Produto'
          id: string
          nome: string
        } | null> | null
      } | null> | null
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
    } | null> | null
  } | null
}

export type GetGrupoQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetGrupoQueryQuery = {
  __typename?: 'Query'
  grupo?: {
    __typename?: 'Grupo'
    id: string
    nome: string
    active: boolean
    marcas?: Array<{
      __typename?: 'Marca'
      id: string
      description: string
    } | null> | null
  } | null
  dealersByGrupo?: Array<{
    __typename?: 'Dealer'
    id: string
    nome: string
    codigoPrincipal: string
  } | null> | null
}

export type GetGrupoByNomeQueryQueryVariables = Exact<{
  nome: Scalars['String']['input']
}>

export type GetGrupoByNomeQueryQuery = {
  __typename?: 'Query'
  grupoByNome?: { __typename?: 'Grupo'; id: string; nome: string } | null
}

export type GrupoDominioQueryQueryVariables = Exact<{ [key: string]: never }>

export type GrupoDominioQueryQuery = {
  __typename?: 'Query'
  marcas?: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null> | null
}

export type SalvarGrupoMutationMutationVariables = Exact<{
  grupo: GrupoInput
}>

export type SalvarGrupoMutationMutation = {
  __typename?: 'Mutation'
  salvarGrupo?: {
    __typename?: 'Grupo'
    id: string
    nome: string
    active: boolean
  } | null
}

export type AtivarGrupoMutationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtivarGrupoMutationMutation = {
  __typename?: 'Mutation'
  ativarGrupo?: {
    __typename?: 'Grupo'
    id: string
    nome: string
    active: boolean
  } | null
}

export type InativarGrupoMutationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InativarGrupoMutationMutation = {
  __typename?: 'Mutation'
  inativarGrupo?: {
    __typename?: 'Grupo'
    id: string
    nome: string
    active: boolean
  } | null
}

export type GruposUsuariosQueryQueryVariables = Exact<{ [key: string]: never }>

export type GruposUsuariosQueryQuery = {
  __typename?: 'Query'
  gruposUsuariosAtivos?: Array<{
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
    publico: boolean
    favorito?: boolean | null
  } | null> | null
}

export type AtualizarGrupoFavoritoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtualizarGrupoFavoritoMutation = {
  __typename?: 'Mutation'
  atualizarGrupoFavorito?: {
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
    favorito?: boolean | null
  } | null
}

export type DepartamentoQueryQueryVariables = Exact<{ [key: string]: never }>

export type DepartamentoQueryQuery = {
  __typename?: 'Query'
  departamentos?: Array<{
    __typename?: 'Departamento'
    id: string
    nome: string
  } | null> | null
}

export type GetGrupoUsuariosDominioQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type GetGrupoUsuariosDominioQueryQuery = {
  __typename?: 'Query'
  usuarioLogado?: {
    __typename?: 'Usuario'
    id: string
    tipo?: { __typename?: 'BaseEnum'; id: string } | null
    tiposUsuarios: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    }>
    marcas?: Array<{
      __typename?: 'Marca'
      id: string
      description: string
    } | null> | null
    funcionalidades?: Array<{
      __typename?: 'Funcionalidade'
      chave: string
    } | null> | null
    produtos: Array<{
      __typename?: 'Produto'
      id: string
      nome: string
      tiposAcesso?: Array<{
        __typename?: 'TipoAcesso'
        id: string
        nome: string
        tiposUsuario?: Array<{
          __typename?: 'BaseEnum'
          id: string
          description: string
        } | null> | null
      } | null> | null
    }>
  } | null
  dealers?: Array<{
    __typename?: 'Dealer'
    id: string
    nomeExibicao: string
    active: boolean
    marcas?: Array<{
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null> | null
  } | null> | null
}

export type GetGrupoUsuariosQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetGrupoUsuariosQueryQuery = {
  __typename?: 'Query'
  grupoUsuarios?: {
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
    todosDealers: boolean
    possuiPerfil: boolean
    possuiUsuariosManuais: boolean
    active: boolean
    possuiCargos: boolean
    possuiSetores: boolean
    publico: boolean
    possuiGrupos?: boolean | null
    possuiDepartamentos?: boolean | null
    marcas?: Array<{ __typename?: 'BaseEnum'; id: string } | null> | null
    tiposUsuarios?: Array<{ __typename?: 'BaseEnum'; id: string } | null> | null
    usuariosManuais?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    } | null> | null
    tiposAcesso?: Array<{
      __typename?: 'TipoAcesso'
      id: string
      produto: { __typename?: 'Produto'; id: string }
    } | null> | null
    criador?: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
      tipo?: { __typename?: 'BaseEnum'; id: string } | null
    } | null
    dealers?: Array<{
      __typename?: 'Dealer'
      id: string
      nomeExibicao: string
    } | null> | null
    cargos?: Array<{
      __typename?: 'Cargo'
      id: string
      nome: string
    } | null> | null
    setores?: Array<{
      __typename?: 'Setor'
      id: string
      nome: string
    } | null> | null
    grupos?: Array<{
      __typename?: 'Grupo'
      id: string
      nome: string
    } | null> | null
    departamentos?: Array<{
      __typename?: 'Departamento'
      id: string
      nome: string
    } | null> | null
  } | null
}

export type GetGrupoUsuarioByNomeQueryQueryVariables = Exact<{
  nome: Scalars['String']['input']
}>

export type GetGrupoUsuarioByNomeQueryQuery = {
  __typename?: 'Query'
  grupoUsuariosByNome?: {
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
  } | null
}

export type SalvarGrupoUsuariosMutationMutationVariables = Exact<{
  grupoUsuarios: GrupoUsuariosInput
}>

export type SalvarGrupoUsuariosMutationMutation = {
  __typename?: 'Mutation'
  salvarGrupoUsuarios?: {
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
  } | null
}

export type UsuariosStartsWithQueryVariables = Exact<{
  nome: Scalars['String']['input']
}>

export type UsuariosStartsWithQuery = {
  __typename?: 'Query'
  usuariosByNomeOrEmailStartingWith?: Array<{
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    active?: boolean | null
  } | null> | null
}

export type InativarGrupoUsuariosMutationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InativarGrupoUsuariosMutationMutation = {
  __typename?: 'Mutation'
  inativarGrupoUsuarios?: {
    __typename?: 'GrupoUsuarios'
    id: string
    active: boolean
  } | null
}

export type AtivarGrupoUsuariosMutationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtivarGrupoUsuariosMutationMutation = {
  __typename?: 'Mutation'
  ativarGrupoUsuarios?: {
    __typename?: 'GrupoUsuarios'
    id: string
    active: boolean
  } | null
}

export type GruposUsuariosFragmentFragment = {
  __typename?: 'GrupoUsuarios'
  id: string
  nome: string
  active: boolean
  possuiPerfil: boolean
  possuiUsuariosManuais: boolean
  publico: boolean
  favorito?: boolean | null
  tipo?: { __typename?: 'BaseEnum'; id: string; description: string } | null
  marcas?: Array<{ __typename?: 'BaseEnum'; description: string } | null> | null
  tiposUsuarios?: Array<{
    __typename?: 'BaseEnum'
    description: string
  } | null> | null
}

export type GruposUsuariosPagedQueryVariables = Exact<{
  filterInput: GrupoUsuariosFilterInput
}>

export type GruposUsuariosPagedQuery = {
  __typename?: 'Query'
  gruposUsuariosPaged?: {
    __typename?: 'GrupoUsuariosPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
      active: boolean
      possuiPerfil: boolean
      possuiUsuariosManuais: boolean
      publico: boolean
      favorito?: boolean | null
      tipo?: { __typename?: 'BaseEnum'; id: string; description: string } | null
      marcas?: Array<{
        __typename?: 'BaseEnum'
        description: string
      } | null> | null
      tiposUsuarios?: Array<{
        __typename?: 'BaseEnum'
        description: string
      } | null> | null
    } | null> | null
  } | null
}

export type AnuncioAleatorioQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type AnuncioAleatorioQueryQuery = {
  __typename?: 'Query'
  anuncioAleatorio?: {
    __typename?: 'Anuncio'
    id: string
    titulo: string
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type SlidesAtivosQueryQueryVariables = Exact<{ [key: string]: never }>

export type SlidesAtivosQueryQuery = {
  __typename?: 'Query'
  slidesAtivos?: Array<{
    __typename?: 'Slide'
    id: string
    titulo: string
    corTitulo: string
    tamanhoTitulo: number
    subtitulo: string
    corSubtitulo: string
    tamanhoSubtitulo: number
    tituloBotao?: string | null
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null> | null
}

export type ImportarUsuariosQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ImportarUsuariosQueryQuery = {
  __typename?: 'Query'
  importStatus?: Array<{
    __typename?: 'ImportStatus'
    total?: number | null
    done?: number | null
    progress?: number | null
    fileName?: string | null
    status?: StatusFile | null
  } | null> | null
}

export type AtualizarMinhaContaMutationMutationVariables = Exact<{
  usuario: AtualizarMinhaContaInput
}>

export type AtualizarMinhaContaMutationMutation = {
  __typename?: 'Mutation'
  atualizarMinhaConta?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    telefones?: Array<string | null> | null
    celulares?: Array<string | null> | null
    avatarLink?: string | null
    avatar?: { __typename?: 'Arquivo'; id: string } | null
  } | null
}

export type AtualizarSenhaMutationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtualizarSenhaMutationMutation = {
  __typename?: 'Mutation'
  atualizarSenha?: boolean | null
}

export type MinhaContaDominioQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type MinhaContaDominioQueryQuery = {
  __typename?: 'Query'
  notificacoesDisponiveisUsuario?: Array<{
    __typename?: 'Notificacao'
    id: string
    chave: string
    descricao: string
    tipos: Array<{ __typename?: 'BaseEnum'; id: string } | null>
    produto: {
      __typename?: 'Produto'
      nome: string
      chave: string
      ordem?: number | null
    }
  } | null> | null
  notificacaoTipos?: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null> | null
}

export type MinhaContaUsuarioQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type MinhaContaUsuarioQueryQuery = {
  __typename?: 'Query'
  usuarioLogado?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    telefones?: Array<string | null> | null
    celulares?: Array<string | null> | null
    avatarLink?: string | null
    avatar?: { __typename?: 'Arquivo'; id: string } | null
    notificacoesUsuario?: Array<{
      __typename?: 'NotificacaoUsuario'
      enabled: boolean
      notificacao: { __typename?: 'Notificacao'; id: string; chave: string }
      tipo: { __typename?: 'BaseEnum'; id: string }
    } | null> | null
  } | null
}

export type EnviarNotificacaoGenericaMutationVariables = Exact<{
  idNotificacaoGenerica: Scalars['ID']['input']
}>

export type EnviarNotificacaoGenericaMutation = {
  __typename?: 'Mutation'
  enviarNotificacaoGenerica: {
    __typename?: 'NotificacaoGenerica'
    id: string
    titulo: string
    texto: string
    link?: string | null
    modelo: boolean
    agendamentoDateTime?: any | null
    envioDateTime?: any | null
    createdDateTime: any
    produto: { __typename?: 'Produto'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
    usuario: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
  }
}

export type NotificacaoGenericaDominioQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type NotificacaoGenericaDominioQueryQuery = {
  __typename?: 'Query'
  gruposUsuariosAtivos?: Array<{
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
    favorito?: boolean | null
  } | null> | null
  produtos?: Array<{
    __typename?: 'Produto'
    id: string
    nome: string
  } | null> | null
}

export type NotificacaoGenericaFragmentFragment = {
  __typename?: 'NotificacaoGenerica'
  id: string
  titulo: string
  texto: string
  link?: string | null
  modelo: boolean
  agendamentoDateTime?: any | null
  envioDateTime?: any | null
  createdDateTime: any
  produto: { __typename?: 'Produto'; id: string; nome: string }
  grupos?: Array<{
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
  }> | null
  usuario: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
  }
}

export type RemoverNotificacaoGenericaMutationVariables = Exact<{
  idNotificacaoGenerica: Scalars['ID']['input']
}>

export type RemoverNotificacaoGenericaMutation = {
  __typename?: 'Mutation'
  removerNotificacaoGenerica?: string | null
}

export type NotificacaoGenericaQueryQueryVariables = Exact<{
  idNotificacaoGenerica: Scalars['ID']['input']
}>

export type NotificacaoGenericaQueryQuery = {
  __typename?: 'Query'
  notificacaoGenerica: {
    __typename?: 'NotificacaoGenerica'
    id: string
    titulo: string
    texto: string
    link?: string | null
    modelo: boolean
    agendamentoDateTime?: any | null
    envioDateTime?: any | null
    createdDateTime: any
    produto: { __typename?: 'Produto'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
    usuario: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
  }
}

export type SalvarNotificacaoGenericaMutationVariables = Exact<{
  notificacaoGenericaInput: NotificacaoGenericaInput
}>

export type SalvarNotificacaoGenericaMutation = {
  __typename?: 'Mutation'
  salvarNotificacaoGenerica: {
    __typename?: 'NotificacaoGenerica'
    id: string
    titulo: string
    texto: string
    link?: string | null
    modelo: boolean
    agendamentoDateTime?: any | null
    envioDateTime?: any | null
    createdDateTime: any
    produto: { __typename?: 'Produto'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
    usuario: {
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
    }
  }
}

export type NotificacoesGenericasQueryQueryVariables = Exact<{
  filterInput: NotificacaoGenericaFilterInput
}>

export type NotificacoesGenericasQueryQuery = {
  __typename?: 'Query'
  notificacoesGenericas?: {
    __typename?: 'NotificacaoGenericaPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'NotificacaoGenerica'
      id: string
      titulo: string
      texto: string
      link?: string | null
      modelo: boolean
      agendamentoDateTime?: any | null
      envioDateTime?: any | null
      createdDateTime: any
      produto: { __typename?: 'Produto'; id: string; nome: string }
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      }> | null
      usuario: {
        __typename?: 'Usuario'
        id: string
        nome?: string | null
        email?: string | null
      }
    } | null> | null
  } | null
}

export type NotificacaoDominioQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type NotificacaoDominioQueryQuery = {
  __typename?: 'Query'
  notificacaoProdutosUsuario?: Array<{
    __typename?: 'Produto'
    id: string
    nome: string
  } | null> | null
}

export type NotificacaoItemUsuarioFragmentFragment = {
  __typename?: 'NotificacaoItemUsuario'
  id: string
  visualizacaoDateTime?: any | null
  usuario: { __typename?: 'Usuario'; id: string }
  notificacaoItem: {
    __typename?: 'NotificacaoItem'
    id: string
    titulo: string
    texto: string
    link?: string | null
    createdDateTime: any
    produto: { __typename?: 'Produto'; id: string; nome: string }
  }
}

export type NotificacaoItensUsuarioQueryQueryVariables = Exact<{
  filterInput: NotificacaoItemUsuarioFilterInput
}>

export type NotificacaoItensUsuarioQueryQuery = {
  __typename?: 'Query'
  notificacaoItensUsuario?: {
    __typename?: 'NotificacaoItemUsuarioPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'NotificacaoItemUsuario'
      id: string
      visualizacaoDateTime?: any | null
      usuario: { __typename?: 'Usuario'; id: string }
      notificacaoItem: {
        __typename?: 'NotificacaoItem'
        id: string
        titulo: string
        texto: string
        link?: string | null
        createdDateTime: any
        produto: { __typename?: 'Produto'; id: string; nome: string }
      }
    } | null> | null
  } | null
}

export type RelatorioQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type RelatorioQuery = {
  __typename?: 'Query'
  relatorio?: {
    __typename?: 'Relatorio'
    id: string
    nome: string
    embedToken: string
  } | null
}

export type AtivarSlideMutationVariables = Exact<{
  idSlide: Scalars['ID']['input']
}>

export type AtivarSlideMutation = {
  __typename?: 'Mutation'
  ativarSlide?: {
    __typename?: 'Slide'
    id: string
    titulo: string
    corTitulo: string
    tamanhoTitulo: number
    subtitulo: string
    corSubtitulo: string
    tamanhoSubtitulo: number
    tituloBotao?: string | null
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type InativarSlideMutationVariables = Exact<{
  idSlide: Scalars['ID']['input']
}>

export type InativarSlideMutation = {
  __typename?: 'Mutation'
  inativarSlide?: {
    __typename?: 'Slide'
    id: string
    titulo: string
    corTitulo: string
    tamanhoTitulo: number
    subtitulo: string
    corSubtitulo: string
    tamanhoSubtitulo: number
    tituloBotao?: string | null
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type RemoverSlideMutationVariables = Exact<{
  idSlide: Scalars['ID']['input']
}>

export type RemoverSlideMutation = {
  __typename?: 'Mutation'
  removerSlide?: string | null
}

export type SlideFragmentFragment = {
  __typename?: 'Slide'
  id: string
  titulo: string
  corTitulo: string
  tamanhoTitulo: number
  subtitulo: string
  corSubtitulo: string
  tamanhoSubtitulo: number
  tituloBotao?: string | null
  link?: string | null
  linkTarget?: string | null
  inicioDate?: any | null
  fimDate?: any | null
  active: boolean
  createdDateTime: any
  emExibicao: boolean
  arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
  grupos?: Array<{
    __typename?: 'GrupoUsuarios'
    id: string
    nome: string
  }> | null
}

export type SlidePageQueryVariables = Exact<{
  filterInput: SlideFilterInput
}>

export type SlidePageQuery = {
  __typename?: 'Query'
  slidesPaged?: {
    __typename?: 'SlidePage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'Slide'
      id: string
      titulo: string
      corTitulo: string
      tamanhoTitulo: number
      subtitulo: string
      corSubtitulo: string
      tamanhoSubtitulo: number
      tituloBotao?: string | null
      link?: string | null
      linkTarget?: string | null
      inicioDate?: any | null
      fimDate?: any | null
      active: boolean
      createdDateTime: any
      emExibicao: boolean
      arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
      grupos?: Array<{
        __typename?: 'GrupoUsuarios'
        id: string
        nome: string
      }> | null
    } | null> | null
  } | null
}

export type SalvarSlideMutationVariables = Exact<{
  slideInput: SlideInput
}>

export type SalvarSlideMutation = {
  __typename?: 'Mutation'
  salvarSlide?: {
    __typename?: 'Slide'
    id: string
    titulo: string
    corTitulo: string
    tamanhoTitulo: number
    subtitulo: string
    corSubtitulo: string
    tamanhoSubtitulo: number
    tituloBotao?: string | null
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type SlideQueryQueryVariables = Exact<{
  idSlide: Scalars['ID']['input']
}>

export type SlideQueryQuery = {
  __typename?: 'Query'
  slide?: {
    __typename?: 'Slide'
    id: string
    titulo: string
    corTitulo: string
    tamanhoTitulo: number
    subtitulo: string
    corSubtitulo: string
    tamanhoSubtitulo: number
    tituloBotao?: string | null
    link?: string | null
    linkTarget?: string | null
    inicioDate?: any | null
    fimDate?: any | null
    active: boolean
    createdDateTime: any
    emExibicao: boolean
    arquivo: { __typename?: 'Arquivo'; id: string; nome: string }
    grupos?: Array<{
      __typename?: 'GrupoUsuarios'
      id: string
      nome: string
    }> | null
  } | null
}

export type LinksExternosQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type LinksExternosQueryQuery = {
  __typename?: 'Query'
  linksExternosByProduto?: Array<{
    __typename?: 'LinkExterno'
    id: string
    label?: string | null
    uri?: string | null
    uriHomolog?: string | null
  } | null> | null
}

export type ImportarGrupoUsuariosMutationMutationVariables = Exact<{
  [key: string]: never
}>

export type ImportarGrupoUsuariosMutationMutation = {
  __typename?: 'Mutation'
  importarGrupoUsuarios?: boolean | null
}

export type ProdutosQueryQueryVariables = Exact<{ [key: string]: never }>

export type ProdutosQueryQuery = {
  __typename?: 'Query'
  produtos?: Array<{
    __typename?: 'Produto'
    id: string
    nome: string
    baseUriHomolog: string
    baseUri: string
  } | null> | null
}

export type EditarProdutoMutationMutationVariables = Exact<{
  produto: ProdutoInput
}>

export type EditarProdutoMutationMutation = {
  __typename?: 'Mutation'
  editarProduto?: boolean | null
}

export type SincronizarDealersMutationMutationVariables = Exact<{
  [key: string]: never
}>

export type SincronizarDealersMutationMutation = {
  __typename?: 'Mutation'
  sincronizarDealers?: boolean | null
}

export type SincronizarGruposMutationMutationVariables = Exact<{
  [key: string]: never
}>

export type SincronizarGruposMutationMutation = {
  __typename?: 'Mutation'
  sincronizarGrupos?: boolean | null
}

export type SincronizarIdentityProviderMutationVariables = Exact<{
  emailUsuario: Scalars['String']['input']
}>

export type SincronizarIdentityProviderMutation = {
  __typename?: 'Mutation'
  sincronizarIdentityProvider?: boolean | null
}

export type SincronizarUsuariosMutationMutationVariables = Exact<{
  [key: string]: never
}>

export type SincronizarUsuariosMutationMutation = {
  __typename?: 'Mutation'
  sincronizarUsuarios?: boolean | null
}

export type UsuarioQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UsuarioQueryQuery = {
  __typename?: 'Query'
  usuario?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    cpf?: string | null
    isEstrangeiro?: boolean | null
    telefones?: Array<string | null> | null
    celulares?: Array<string | null> | null
    tipoDocumento?: {
      __typename?: 'BaseEnum'
      id: string
      description: string
    } | null
    tiposAcesso?: Array<{
      __typename?: 'TipoAcesso'
      id: string
      nome: string
      produto: { __typename?: 'Produto'; id: string }
    } | null> | null
    funcionalidades?: Array<{
      __typename?: 'Funcionalidade'
      id: string
      produto: { __typename?: 'Produto'; id: string }
    } | null> | null
    tipo?: { __typename?: 'BaseEnum'; id: string; description: string } | null
    idioma?: { __typename?: 'BaseEnum'; id: string } | null
    marcas?: Array<{ __typename?: 'Marca'; id: string } | null> | null
    grupos?: Array<{ __typename?: 'Grupo'; id: string } | null> | null
    dealers?: Array<{
      __typename?: 'Dealer'
      id: string
      active: boolean
      nomeExibicao: string
      grupo: { __typename?: 'Grupo'; id: string }
    } | null> | null
  } | null
}

export type UsuariosQueryQueryVariables = Exact<{ [key: string]: never }>

export type UsuariosQueryQuery = {
  __typename?: 'Query'
  usuarios?: Array<{
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    keycloakId?: string | null
    active?: boolean | null
    especial: boolean
    ativacaoEspecial: boolean
    tipo?: { __typename?: 'BaseEnum'; id: string; description: string } | null
    marcas?: Array<{
      __typename?: 'Marca'
      id: string
      description: string
    } | null> | null
    funcionalidades?: Array<{
      __typename?: 'Funcionalidade'
      id: string
      nome: string
      produto: { __typename?: 'Produto'; id: string; nome: string }
    } | null> | null
    dealers?: Array<{
      __typename?: 'Dealer'
      id: string
      nome: string
      nomeExibicao: string
      codigoPrincipal: string
    } | null> | null
  } | null> | null
}

export type CargoFragmentFragment = {
  __typename?: 'Cargo'
  id: string
  nome: string
}

export type CargosByUsuarioQueryVariables = Exact<{
  usuarioId?: InputMaybe<Scalars['ID']['input']>
}>

export type CargosByUsuarioQuery = {
  __typename?: 'Query'
  cargos?: Array<{
    __typename?: 'Cargo'
    dataInicio?: any | null
    id: string
    nome: string
    dealer?: { __typename?: 'Dealer'; id: string; nome: string } | null
    departamento?: {
      __typename?: 'Departamento'
      id: string
      nome: string
    } | null
  } | null> | null
}

export type CargosQueryVariables = Exact<{
  cargosPrincipais?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type CargosQuery = {
  __typename?: 'Query'
  cargos?: Array<{
    __typename?: 'Cargo'
    id: string
    nome: string
  } | null> | null
}

export type PodeAdicionarCargoQueryVariables = Exact<{
  podeAdicionarCargoInput: PodeAdicionarCargoInput
}>

export type PodeAdicionarCargoQuery = {
  __typename?: 'Query'
  podeAdicionarCargo?: boolean | null
}

export type DesligamentoQueryVariables = Exact<{ [key: string]: never }>

export type DesligamentoQuery = {
  __typename?: 'Query'
  desligamentos?: Array<{
    __typename?: 'Desligamento'
    id: string
    motivo: string
  } | null> | null
}

export type InfoUsuarioQueryQueryVariables = Exact<{
  usuarioId: Scalars['ID']['input']
}>

export type InfoUsuarioQueryQuery = {
  __typename?: 'Query'
  infoUsuario?: {
    __typename?: 'InfoUsuario'
    id: string
    dataAdmissao?: any | null
    emailSuperior?: string | null
    dataDesligamento?: any | null
    desligamento?: {
      __typename?: 'Desligamento'
      id: string
      motivo: string
    } | null
  } | null
}

export type SalvarUsuarioMutationVariables = Exact<{
  usuario: UsuarioInput
  cargos: Array<InputMaybe<CargoInput>> | InputMaybe<CargoInput>
  infos?: InputMaybe<InfoUsuarioInput>
}>

export type SalvarUsuarioMutation = {
  __typename?: 'Mutation'
  salvarUsuario?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    cpf?: string | null
    telefones?: Array<string | null> | null
    celulares?: Array<string | null> | null
    tipoDocumento?: { __typename?: 'BaseEnum'; id: string } | null
    tiposAcesso?: Array<{
      __typename?: 'TipoAcesso'
      id: string
      produto: { __typename?: 'Produto'; id: string }
    } | null> | null
    funcionalidades?: Array<{
      __typename?: 'Funcionalidade'
      id: string
      chave: string
      nome: string
      descricao?: string | null
    } | null> | null
    tipo?: { __typename?: 'BaseEnum'; id: string } | null
    idioma?: { __typename?: 'BaseEnum'; id: string } | null
    marcas?: Array<{ __typename?: 'Marca'; id: string } | null> | null
  } | null
}

export type UsuarioEdicaoSecondPageQueryQueryVariables = Exact<{
  idsDealer?: InputMaybe<
    | Array<InputMaybe<Scalars['ID']['input']>>
    | InputMaybe<Scalars['ID']['input']>
  >
  tipoUsuario: Scalars['ID']['input']
}>

export type UsuarioEdicaoSecondPageQueryQuery = {
  __typename?: 'Query'
  produtosByDealersAndTipoUsuario?: Array<{
    __typename?: 'Produto'
    id: string
    nome: string
    tiposAcesso?: Array<{
      __typename?: 'TipoAcesso'
      id: string
      nome: string
      funcionalidadesPadrao?: Array<{
        __typename?: 'Funcionalidade'
        id: string
      } | null> | null
    } | null> | null
    funcionalidades?: Array<{
      __typename?: 'Funcionalidade'
      id: string
      nome: string
      descricao?: string | null
      tiposAcesso?: Array<{
        __typename?: 'TipoAcesso'
        id: string
        nome: string
      } | null> | null
    } | null> | null
  } | null> | null
}

export type UsuarioByCpfQueryQueryVariables = Exact<{
  cpf: Scalars['String']['input']
}>

export type UsuarioByCpfQueryQuery = {
  __typename?: 'Query'
  usuarioByCpf?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    cpf?: string | null
  } | null
}

export type UsuarioByEmailQueryQueryVariables = Exact<{
  email: Scalars['String']['input']
}>

export type UsuarioByEmailQueryQuery = {
  __typename?: 'Query'
  usuarioByEmail?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
  } | null
}

export type UsuarioDominioQueryQueryVariables = Exact<{ [key: string]: never }>

export type UsuarioDominioQueryQuery = {
  __typename?: 'Query'
  produtos?: Array<{
    __typename?: 'Produto'
    id: string
    nome: string
    tiposAcesso?: Array<{
      __typename?: 'TipoAcesso'
      id: string
      nome: string
      funcionalidadesPadrao?: Array<{
        __typename?: 'Funcionalidade'
        id: string
      } | null> | null
    } | null> | null
  } | null> | null
  idiomas?: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null> | null
  grupos?: Array<{
    __typename?: 'Grupo'
    id: string
    nome: string
    marcas?: Array<{
      __typename?: 'Marca'
      id: string
      description: string
    } | null> | null
  } | null> | null
  dealers?: Array<{
    __typename?: 'Dealer'
    id: string
    nomeExibicao: string
    active: boolean
    grupo: { __typename?: 'Grupo'; id: string }
  } | null> | null
  funcionalidades?: Array<{
    __typename?: 'Funcionalidade'
    id: string
    descricao?: string | null
  } | null> | null
  marcas?: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null> | null
  tiposUsuario?: Array<{
    __typename?: 'BaseEnum'
    id: string
    description: string
  } | null> | null
}

export type UsuariosPortalPropertiesQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type UsuariosPortalPropertiesQueryQuery = {
  __typename?: 'Query'
  usuariosPortalProperties: {
    __typename?: 'UsuariosPortalProperties'
    informarDepartamentoCargo: boolean
    tiposUsuarioDocumentoObrigatorio: Array<{
      __typename?: 'BaseEnum'
      id: string
    } | null>
    tiposUsuarioInformarCargo: Array<{
      __typename?: 'BaseEnum'
      id: string
    } | null>
    tiposUsuarioInformarGestao: Array<{
      __typename?: 'BaseEnum'
      id: string
    } | null>
  }
}

export type UsuariosTipoAcessoByTipoQueryVariables = Exact<{
  tipoUsuario: Scalars['String']['input']
  dealerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  busca?: InputMaybe<Scalars['String']['input']>
}>

export type UsuariosTipoAcessoByTipoQuery = {
  __typename?: 'Query'
  usuariosByTipoUsuario?: Array<{
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    tiposAcesso?: Array<{
      __typename?: 'TipoAcesso'
      id: string
      nome: string
      produto: { __typename?: 'Produto'; id: string; nome: string }
    } | null> | null
    funcionalidades?: Array<{
      __typename?: 'Funcionalidade'
      id: string
      produto: { __typename?: 'Produto'; id: string }
    } | null> | null
  } | null> | null
}

export type AtivarUsuarioMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtivarUsuarioMutation = {
  __typename?: 'Mutation'
  ativarUsuario?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    active?: boolean | null
    keycloakId?: string | null
  } | null
}

export type ExportarUsuariosMutationVariables = Exact<{
  filtro: UsuarioFilterInput
}>

export type ExportarUsuariosMutation = {
  __typename?: 'Mutation'
  exportarUsuarios?: boolean | null
}

export type InativarUsuarioMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InativarUsuarioMutation = {
  __typename?: 'Mutation'
  inativarUsuario?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    email?: string | null
    active?: boolean | null
    keycloakId?: string | null
  } | null
}

export type UsuarioDadosComplementaresQueryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UsuarioDadosComplementaresQueryQuery = {
  __typename?: 'Query'
  usuario?: {
    __typename?: 'Usuario'
    id: string
    nome?: string | null
    dadosComplementares: Array<{
      __typename?: 'DadoComplementar'
      id: string
      descricao: string
      urlBase: string
      ordem: number
      tipo: string
    } | null>
  } | null
}

export type UsuarioFragmentFragment = {
  __typename?: 'Usuario'
  id: string
  nome?: string | null
  email?: string | null
  keycloakId?: string | null
  active?: boolean | null
  ativacaoEspecial: boolean
  ausenteTemporariamente: boolean
  tipo?: { __typename?: 'BaseEnum'; id: string; description: string } | null
  marcas?: Array<{
    __typename?: 'Marca'
    id: string
    description: string
  } | null> | null
  funcionalidades?: Array<{
    __typename?: 'Funcionalidade'
    id: string
    nome: string
    produto: { __typename?: 'Produto'; id: string; nome: string }
  } | null> | null
  dealers?: Array<{
    __typename?: 'Dealer'
    id: string
    nome: string
    nomeExibicao: string
    codigoPrincipal: string
  } | null> | null
  dadosComplementares: Array<{
    __typename?: 'DadoComplementar'
    id: string
    tipo: string
  } | null>
}

export type UsuarioPagedQueryVariables = Exact<{
  filterInput: UsuarioFilterInput
}>

export type UsuarioPagedQuery = {
  __typename?: 'Query'
  usuariosPaged?: {
    __typename?: 'UsuarioPage'
    totalElements?: number | null
    content?: Array<{
      __typename?: 'Usuario'
      id: string
      nome?: string | null
      email?: string | null
      keycloakId?: string | null
      active?: boolean | null
      ativacaoEspecial: boolean
      ausenteTemporariamente: boolean
      tipo?: { __typename?: 'BaseEnum'; id: string; description: string } | null
      marcas?: Array<{
        __typename?: 'Marca'
        id: string
        description: string
      } | null> | null
      funcionalidades?: Array<{
        __typename?: 'Funcionalidade'
        id: string
        nome: string
        produto: { __typename?: 'Produto'; id: string; nome: string }
      } | null> | null
      dealers?: Array<{
        __typename?: 'Dealer'
        id: string
        nome: string
        nomeExibicao: string
        codigoPrincipal: string
      } | null> | null
      dadosComplementares: Array<{
        __typename?: 'DadoComplementar'
        id: string
        tipo: string
      } | null>
    } | null> | null
  } | null
}

export type PermissoesPorTipoUsuarioQueryVariables = Exact<{
  tipoUsuario: Scalars['String']['input']
  produtos?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >
}>

export type PermissoesPorTipoUsuarioQuery = {
  __typename?: 'Query'
  permissoesPorTipoUsuario?: Array<{
    __typename?: 'TipoAcesso'
    id: string
    nome: string
  } | null> | null
}

export type GerarPushSubscriptionMutationVariables = Exact<{
  input: PushSubscriptionInput
}>

export type GerarPushSubscriptionMutation = {
  __typename?: 'Mutation'
  gerarPushSubscription: boolean
}
